
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5ed8027d647799b$var$t = globalThis, $e5ed8027d647799b$var$i = $e5ed8027d647799b$var$t.trustedTypes, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$e = "$lit$", $e5ed8027d647799b$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $e5ed8027d647799b$var$o = "?" + $e5ed8027d647799b$var$h, $e5ed8027d647799b$var$n = `<${$e5ed8027d647799b$var$o}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$l = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$a = Array.isArray, $e5ed8027d647799b$var$u = (t)=>$e5ed8027d647799b$var$a(t) || "function" == typeof t?.[Symbol.iterator], $e5ed8027d647799b$var$d = "[ \t\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$v = /-->/g, $e5ed8027d647799b$var$_ = />/g, $e5ed8027d647799b$var$m = RegExp(`>|${$e5ed8027d647799b$var$d}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$d}*=${$e5ed8027d647799b$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$p = /'/g, $e5ed8027d647799b$var$g = /"/g, $e5ed8027d647799b$var$$ = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$y(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$y(2), $e5ed8027d647799b$export$47d5b44d225be5b4 = $e5ed8027d647799b$var$y(3), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$A = new WeakMap, $e5ed8027d647799b$var$C = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129);
function $e5ed8027d647799b$var$P(t, i) {
    if (!$e5ed8027d647799b$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createHTML(i) : i;
}
const $e5ed8027d647799b$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $e5ed8027d647799b$var$f ? "!--" === u[1] ? c = $e5ed8027d647799b$var$v : void 0 !== u[1] ? c = $e5ed8027d647799b$var$_ : void 0 !== u[2] ? ($e5ed8027d647799b$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $e5ed8027d647799b$var$m) : void 0 !== u[3] && (c = $e5ed8027d647799b$var$m) : c === $e5ed8027d647799b$var$m ? ">" === u[0] ? (c = r ?? $e5ed8027d647799b$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e5ed8027d647799b$var$m : '"' === u[3] ? $e5ed8027d647799b$var$g : $e5ed8027d647799b$var$p) : c === $e5ed8027d647799b$var$g || c === $e5ed8027d647799b$var$p ? c = $e5ed8027d647799b$var$m : c === $e5ed8027d647799b$var$v || c === $e5ed8027d647799b$var$_ ? c = $e5ed8027d647799b$var$f : (c = $e5ed8027d647799b$var$m, r = void 0);
        const x = c === $e5ed8027d647799b$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $e5ed8027d647799b$var$e + s.slice(d) + $e5ed8027d647799b$var$h + x) : s + $e5ed8027d647799b$var$h + (-2 === d ? i : x);
    }
    return [
        $e5ed8027d647799b$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $e5ed8027d647799b$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e5ed8027d647799b$var$V(t, s);
        if (this.el = $e5ed8027d647799b$var$N.createElement(f, n), $e5ed8027d647799b$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e5ed8027d647799b$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e5ed8027d647799b$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($e5ed8027d647799b$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e5ed8027d647799b$var$H : "?" === e[1] ? $e5ed8027d647799b$var$I : "@" === e[1] ? $e5ed8027d647799b$var$L : $e5ed8027d647799b$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($e5ed8027d647799b$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($e5ed8027d647799b$var$$.test(r.tagName)) {
                    const t = r.textContent.split($e5ed8027d647799b$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $e5ed8027d647799b$var$l()), $e5ed8027d647799b$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $e5ed8027d647799b$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e5ed8027d647799b$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e5ed8027d647799b$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $e5ed8027d647799b$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$S(t, i, s = t, e) {
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e5ed8027d647799b$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e5ed8027d647799b$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $e5ed8027d647799b$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e5ed8027d647799b$var$r).importNode(i, !0);
        $e5ed8027d647799b$var$C.currentNode = e;
        let h = $e5ed8027d647799b$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $e5ed8027d647799b$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $e5ed8027d647799b$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $e5ed8027d647799b$var$C.nextNode(), o++);
        }
        return $e5ed8027d647799b$var$C.currentNode = $e5ed8027d647799b$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$S(this, t, i), $e5ed8027d647799b$var$c(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e5ed8027d647799b$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e5ed8027d647799b$var$N.createElement($e5ed8027d647799b$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e5ed8027d647799b$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$A.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$A.set(t.strings, i = new $e5ed8027d647799b$var$N(t)), i;
    }
    k(t) {
        $e5ed8027d647799b$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$R(this.O($e5ed8027d647799b$var$l()), this.O($e5ed8027d647799b$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e5ed8027d647799b$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e5ed8027d647799b$var$S(this, t, i, 0), o = !$e5ed8027d647799b$var$c(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e5ed8027d647799b$var$S(this, e[s + n], i, n), r === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e5ed8027d647799b$var$c(r) || r !== this._$AH[n], r === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e5ed8027d647799b$export$45b790e32b2810ee);
    }
}
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e5ed8027d647799b$var$S(this, t, i, 0) ?? $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e5ed8027d647799b$export$45b790e32b2810ee && s !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (s === $e5ed8027d647799b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$S(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    M: $e5ed8027d647799b$var$e,
    P: $e5ed8027d647799b$var$h,
    A: $e5ed8027d647799b$var$o,
    C: 1,
    L: $e5ed8027d647799b$var$V,
    R: $e5ed8027d647799b$var$M,
    D: $e5ed8027d647799b$var$u,
    V: $e5ed8027d647799b$var$S,
    I: $e5ed8027d647799b$var$R,
    H: $e5ed8027d647799b$var$k,
    N: $e5ed8027d647799b$var$I,
    U: $e5ed8027d647799b$var$L,
    B: $e5ed8027d647799b$var$H,
    F: $e5ed8027d647799b$var$z
}, $e5ed8027d647799b$var$j = $e5ed8027d647799b$var$t.litHtmlPolyfillSupport;
$e5ed8027d647799b$var$j?.($e5ed8027d647799b$var$N, $e5ed8027d647799b$var$R), ($e5ed8027d647799b$var$t.litHtmlVersions ??= []).push("3.2.1");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e5ed8027d647799b$var$R(i.insertBefore($e5ed8027d647799b$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $ead5767561d7cbc1$var$t } = (0, $e5ed8027d647799b$export$8613d1ca9052b22e), $ead5767561d7cbc1$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $ead5767561d7cbc1$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $ead5767561d7cbc1$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $ead5767561d7cbc1$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $ead5767561d7cbc1$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $ead5767561d7cbc1$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $ead5767561d7cbc1$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $ead5767561d7cbc1$var$s = ()=>document.createComment(""), $ead5767561d7cbc1$export$291b2338ad9b0b30 = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore($ead5767561d7cbc1$var$s(), l), c = e.insertBefore($ead5767561d7cbc1$var$s(), l);
        n = new $ead5767561d7cbc1$var$t(i, c, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, c = i !== o;
        if (c) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || c) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, $ead5767561d7cbc1$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $ead5767561d7cbc1$var$u = {}, $ead5767561d7cbc1$export$ea70d9dd5965b1c8 = (o, t = $ead5767561d7cbc1$var$u)=>o._$AH = t, $ead5767561d7cbc1$export$59e9bce518cde500 = (o)=>o._$AH, $ead5767561d7cbc1$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $ead5767561d7cbc1$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e41d1b66de65ecc4$var$u = (e, s, t)=>{
    const r = new Map;
    for(let l = s; l <= t; l++)r.set(e[l], l);
    return r;
}, $e41d1b66de65ecc4$export$76d90c956114f2c2 = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(e){
        if (super(e), e.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).CHILD) throw Error("repeat() can only be used in text expressions");
    }
    dt(e, s, t) {
        let r;
        void 0 === t ? t = s : void 0 !== s && (r = s);
        const l = [], o = [];
        let i = 0;
        for (const s of e)l[i] = r ? r(s, i) : i, o[i] = t(s, i), i++;
        return {
            values: o,
            keys: l
        };
    }
    render(e, s, t) {
        return this.dt(e, s, t).values;
    }
    update(s, [t, r, c]) {
        const d = (0, $ead5767561d7cbc1$export$59e9bce518cde500)(s), { values: p, keys: a } = this.dt(t, r, c);
        if (!Array.isArray(d)) return this.ut = a, p;
        const h = this.ut ??= [], v = [];
        let m, y, x = 0, j = d.length - 1, k = 0, w = p.length - 1;
        for(; x <= j && k <= w;)if (null === d[x]) x++;
        else if (null === d[j]) j--;
        else if (h[x] === a[k]) v[k] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(d[x], p[k]), x++, k++;
        else if (h[j] === a[w]) v[w] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(d[j], p[w]), j--, w--;
        else if (h[x] === a[w]) v[w] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(d[x], p[w]), (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, v[w + 1], d[x]), x++, w--;
        else if (h[j] === a[k]) v[k] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(d[j], p[k]), (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, d[x], d[j]), j--, k++;
        else if (void 0 === m && (m = $e41d1b66de65ecc4$var$u(a, k, w), y = $e41d1b66de65ecc4$var$u(h, x, j)), m.has(h[x])) {
            if (m.has(h[j])) {
                const e = y.get(a[k]), t = void 0 !== e ? d[e] : null;
                if (null === t) {
                    const e = (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, d[x]);
                    (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(e, p[k]), v[k] = e;
                } else v[k] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(t, p[k]), (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, d[x], t), d[e] = null;
                k++;
            } else (0, $ead5767561d7cbc1$export$3133b3144bbba267)(d[j]), j--;
        } else (0, $ead5767561d7cbc1$export$3133b3144bbba267)(d[x]), x++;
        for(; k <= w;){
            const e = (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, v[w + 1]);
            (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(e, p[k]), v[k++] = e;
        }
        for(; x <= j;){
            const e = d[x++];
            null !== e && (0, $ead5767561d7cbc1$export$3133b3144bbba267)(e);
        }
        return this.ut = a, (0, $ead5767561d7cbc1$export$ea70d9dd5965b1c8)(s, v), $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
});


var $ee083671c43a5e14$exports = {};

$parcel$export($ee083671c43a5e14$exports, "distance", () => $ee083671c43a5e14$export$9f17032d917177de);
$parcel$export($ee083671c43a5e14$exports, "distanceSquared", () => $ee083671c43a5e14$export$d019ad931e844842);
$parcel$export($ee083671c43a5e14$exports, "midpoint", () => $ee083671c43a5e14$export$f2e8a19be46147af);
$parcel$export($ee083671c43a5e14$exports, "closest", () => $ee083671c43a5e14$export$ff7f7c97cdce86e);
$parcel$export($ee083671c43a5e14$exports, "isPointInCircle", () => $ee083671c43a5e14$export$489c99c59eb9ceb1);
$parcel$export($ee083671c43a5e14$exports, "isPointInRectangle", () => $ee083671c43a5e14$export$4a253f8fe7a58694);
$parcel$export($ee083671c43a5e14$exports, "isPointInLine", () => $ee083671c43a5e14$export$ff9583e4b2d0fe53);
$parcel$export($ee083671c43a5e14$exports, "moveTowards", () => $ee083671c43a5e14$export$5145a8075501ee31);
$parcel$export($ee083671c43a5e14$exports, "interpolate", () => $ee083671c43a5e14$export$89e29e4ab65e70a9);
const $ee083671c43a5e14$export$9f17032d917177de = (p1, p2)=>{
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    return Math.sqrt(dx * dx + dy * dy);
};
const $ee083671c43a5e14$export$d019ad931e844842 = (p1, p2)=>{
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    return dx * dx + dy * dy;
};
const $ee083671c43a5e14$export$f2e8a19be46147af = (p1, p2)=>({
        x: (p1.x + p2.x) / 2,
        y: (p1.y + p2.y) / 2
    });
const $ee083671c43a5e14$export$ff7f7c97cdce86e = (target, points)=>{
    if (!points.length) throw new Error('Points array is empty');
    return points.reduce((closest, point)=>$ee083671c43a5e14$export$d019ad931e844842(target, point) < $ee083671c43a5e14$export$d019ad931e844842(target, closest) ? point : closest);
};
const $ee083671c43a5e14$export$489c99c59eb9ceb1 = (point, circle)=>{
    const distSquared = $ee083671c43a5e14$export$d019ad931e844842(point, {
        x: circle.x,
        y: circle.y
    });
    return distSquared < circle.radius * circle.radius;
};
const $ee083671c43a5e14$export$4a253f8fe7a58694 = (point, rect)=>point.x >= rect.x && point.x <= rect.x + rect.width && point.y >= rect.y && point.y <= rect.y + rect.height;
const $ee083671c43a5e14$export$ff9583e4b2d0fe53 = (point, line, width = 1)=>{
    const dx = line.end.x - line.start.x;
    const dy = line.end.y - line.start.y;
    const lineLength = Math.sqrt(dx * dx + dy * dy);
    if (lineLength === 0) return $ee083671c43a5e14$export$9f17032d917177de(point, line.start) <= width / 2;
    const t = ((point.x - line.start.x) * dx + (point.y - line.start.y) * dy) / (lineLength * lineLength);
    if (t < 0) return $ee083671c43a5e14$export$9f17032d917177de(point, line.start) <= width / 2;
    if (t > 1) return $ee083671c43a5e14$export$9f17032d917177de(point, line.end) <= width / 2;
    const projX = line.start.x + t * dx;
    const projY = line.start.y + t * dy;
    const distToLine = $ee083671c43a5e14$export$9f17032d917177de(point, {
        x: projX,
        y: projY
    });
    return distToLine <= width / 2;
};
const $ee083671c43a5e14$export$5145a8075501ee31 = (current, target, maxDistance)=>{
    if (maxDistance <= 0) return current;
    const dx = target.x - current.x;
    const dy = target.y - current.y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    if (dist <= maxDistance || dist === 0) return target;
    return {
        x: current.x + dx / dist * maxDistance,
        y: current.y + dy / dist * maxDistance
    };
};
const $ee083671c43a5e14$export$89e29e4ab65e70a9 = (p1, p2, t)=>({
        x: p1.x + (p2.x - p1.x) * Math.max(0, Math.min(1, t)),
        y: p1.y + (p2.y - p1.y) * Math.max(0, Math.min(1, t))
    });


function $086612735116fd75$export$8b59d3c9ad87edcd(canvas, evt) {
    const rect = canvas.getBoundingClientRect();
    return {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top
    };
}
function $086612735116fd75$export$a1c066623ac679d3(ctx) {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
}
function $086612735116fd75$export$654275d54901f10e(ctx, p, color = 'blue', size = 5) {
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.arc(p.x, p.y, size, 0, Math.PI * 2);
    ctx.fill();
}
function $086612735116fd75$export$8daab6f91f7ff730(ctx, circle, color = 'blue', fill = false) {
    ctx.beginPath();
    ctx.arc(circle.x, circle.y, circle.radius, 0, Math.PI * 2);
    if (fill) {
        ctx.fillStyle = color;
        ctx.fill();
    } else {
        ctx.strokeStyle = color;
        ctx.stroke();
    }
}
function $086612735116fd75$export$819db45aec5fcbe5(ctx, line, color = 'gray', width = 1) {
    ctx.strokeStyle = color;
    ctx.lineWidth = width;
    ctx.beginPath();
    ctx.moveTo(line.start.x, line.start.y);
    ctx.lineTo(line.end.x, line.end.y);
    ctx.stroke();
}
function $086612735116fd75$export$92e8c004f9e4bf7d(ctx, rect, color = 'blue', fill = false) {
    if (fill) {
        ctx.fillStyle = color;
        ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
    } else {
        ctx.strokeStyle = color;
        ctx.strokeRect(rect.x, rect.y, rect.width, rect.height);
    }
}
function $086612735116fd75$export$f6d70d79295e1392(ctx, from, to, color = 'blue') {
    const headSize = 10;
    const angle = Math.atan2(to.y - from.y, to.x - from.x);
    $086612735116fd75$export$819db45aec5fcbe5(ctx, {
        start: from,
        end: to
    }, color);
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.moveTo(to.x, to.y);
    ctx.lineTo(to.x - headSize * Math.cos(angle - Math.PI / 6), to.y - headSize * Math.sin(angle - Math.PI / 6));
    ctx.lineTo(to.x - headSize * Math.cos(angle + Math.PI / 6), to.y - headSize * Math.sin(angle + Math.PI / 6));
    ctx.fill();
}
function $086612735116fd75$export$b11bd9a0808bdc9(ctx, text, x, y, color = 'black', font = '14px monospace') {
    ctx.fillStyle = color;
    ctx.font = font;
    ctx.fillText(text, x, y);
}
function $086612735116fd75$export$bf8a3f9983094125(ctx, center, radius, startAngle, endAngle, color = 'black') {
    ctx.beginPath();
    ctx.arc(center.x, center.y, radius, startAngle, endAngle);
    ctx.strokeStyle = color;
    ctx.stroke();
}
function $086612735116fd75$var$formatValue(value, precision = 2) {
    const num = (n)=>n.toFixed(precision);
    if (typeof value === 'number') return num(value);
    if (typeof value === 'string') return value;
    if (typeof value === 'boolean') return value ? "\u2705 Yes" : "\u274C No";
    if (Array.isArray(value)) return `{${value.map(([k, v])=>`${k}=${$086612735116fd75$var$formatValue(v, precision)}`).join(', ')}}`;
    if ('radius' in value) return `(${num(value.x)}, ${num(value.y)}, r=${num(value.radius)})`;
    if ('width' in value) return `(${num(value.x)}, ${num(value.y)}) [${num(value.width)}\xd7${num(value.height)}]`;
    if ('start' in value) {
        const start = `${num(value.start.x)}, ${num(value.start.y)}`;
        const end = `${num(value.end.x)}, ${num(value.end.y)}`;
        return `(${start}) \u{2192} (${end})`;
    }
    return `(${num(value.x)}, ${num(value.y)})`;
}
function $086612735116fd75$export$4880d2177ba2b4c0(ctx, results, { x: x = 10, y: y = 20, spacing: spacing = 20, precision: precision = 2, color: color = 'black' } = {}) {
    results.forEach((entry, i)=>{
        const text = Array.isArray(entry) ? `${entry[0]}: ${$086612735116fd75$var$formatValue(entry[1], entry[2]?.precision ?? precision)}` : entry;
        $086612735116fd75$export$b11bd9a0808bdc9(ctx, text, x, y + i * spacing, Array.isArray(entry) && entry[2]?.color || color);
    });
}
function $086612735116fd75$export$63550218646aa6fc(canvas, evt, center = {
    x: 0,
    y: 0
}) {
    const pos = $086612735116fd75$export$8b59d3c9ad87edcd(canvas, evt);
    return {
        x: pos.x - center.x,
        y: pos.y - center.y
    };
}
function $086612735116fd75$export$d7d5d435647ed5a0({ canvas: canvas, draw: draw, center: center = {
    x: 0,
    y: 0
} }, handlers) {
    let isDragging = false;
    canvas.addEventListener('mousedown', (e)=>{
        isDragging = true;
        handlers.onStart?.($086612735116fd75$export$63550218646aa6fc(canvas, e, center)) ?? handlers.onDrag?.($086612735116fd75$export$63550218646aa6fc(canvas, e, center));
        draw?.();
    });
    canvas.addEventListener('mousemove', (e)=>{
        if (isDragging) {
            handlers.onDrag?.($086612735116fd75$export$63550218646aa6fc(canvas, e, center));
            draw?.();
        }
    });
    canvas.addEventListener('mouseup', (e)=>{
        if (isDragging) {
            handlers.onEnd?.($086612735116fd75$export$63550218646aa6fc(canvas, e, center));
            isDragging = false;
            draw?.();
        }
    });
    canvas.addEventListener('mouseleave', (e)=>{
        if (isDragging) {
            handlers.onEnd?.($086612735116fd75$export$63550218646aa6fc(canvas, e, center));
            isDragging = false;
            draw?.();
        }
    });
}
function $086612735116fd75$export$64ef1bee2b9504c1({ canvas: canvas, draw: draw, center: center = {
    x: 0,
    y: 0
} }, handler) {
    canvas.addEventListener('click', (e)=>{
        handler($086612735116fd75$export$63550218646aa6fc(canvas, e, center));
        draw?.();
    });
}
function $086612735116fd75$export$d947e5f4f4c48d48({ canvas: canvas, draw: draw, center: center = {
    x: 0,
    y: 0
} }, handler) {
    canvas.addEventListener('mousemove', (e)=>{
        handler($086612735116fd75$export$63550218646aa6fc(canvas, e, center));
        draw?.();
    });
}
function $086612735116fd75$export$df61b30b684217c0({ canvas: canvas, draw: draw }, mappings) {
    // Normalize keys to handle case-insensitivity and special key pairs
    const normalizeKey = (key)=>({
            '+': '=',
            '-': '_'
        })[key.toLowerCase()] ?? key.toLowerCase();
    // Transform mappings into normalized handlers
    const handlers = Object.entries(mappings).reduce((acc, [keys, callback])=>{
        keys.split('').forEach((key)=>acc[normalizeKey(key.trim())] = callback);
        return acc;
    }, {});
    const handler = (e)=>{
        const callback = handlers[normalizeKey(e.key)];
        if (callback) {
            callback();
            draw?.();
        }
    };
    canvas.tabIndex = 0;
    canvas.focus();
    canvas.addEventListener('keydown', handler);
    return ()=>canvas.removeEventListener('keydown', handler);
}
let $086612735116fd75$var$currentAnimation = null;
function $086612735116fd75$export$e3607ec2d7a891c4(draw, udpate) {
    function loop() {
        udpate?.();
        draw();
        $086612735116fd75$var$currentAnimation = requestAnimationFrame(loop);
    }
    loop();
}
function $086612735116fd75$export$1e61084297db69ac(update, draw) {
    let lastTime = performance.now();
    $086612735116fd75$export$e3607ec2d7a891c4(draw, ()=>{
        const time = performance.now();
        const deltaTime = Math.min((time - lastTime) / 1000, 0.1); // Cap at 100ms
        lastTime = time;
        update(deltaTime);
    });
}
function $086612735116fd75$export$aad8462122ac592b() {
    if ($086612735116fd75$var$currentAnimation !== null) {
        cancelAnimationFrame($086612735116fd75$var$currentAnimation);
        $086612735116fd75$var$currentAnimation = null;
    }
    $086612735116fd75$export$ed97f33186d4b816.stop();
}
function $086612735116fd75$export$b602ad7a6da8e372(ctx, center, drawFn) {
    ctx.save();
    ctx.translate(center.x, center.y);
    drawFn(ctx);
    ctx.restore();
}
function $086612735116fd75$export$712d35b7f1932be6(ctx) {
    const width = ctx.canvas.width;
    const height = ctx.canvas.height;
    ctx.strokeStyle = 'lightgray';
    ctx.lineWidth = 1;
    // Draw horizontal axis
    ctx.beginPath();
    ctx.moveTo(-width / 2, 0);
    ctx.lineTo(width / 2, 0);
    ctx.stroke();
    // Draw vertical axis
    ctx.beginPath();
    ctx.moveTo(0, -height / 2);
    ctx.lineTo(0, height / 2);
    ctx.stroke();
}
const $086612735116fd75$export$ed97f33186d4b816 = (()=>{
    const pressedKeys = new Set();
    let listener = null;
    return {
        listen () {
            if (listener) return; // Avoid multiple listeners
            listener = (e)=>{
                if (e.type === 'keydown') pressedKeys.add(e.code);
                if (e.type === 'keyup') pressedKeys.delete(e.code);
            };
            window.addEventListener('keydown', listener);
            window.addEventListener('keyup', listener);
        },
        isDown (keyCode) {
            return pressedKeys.has(keyCode);
        },
        stop () {
            if (listener) {
                window.removeEventListener('keydown', listener);
                window.removeEventListener('keyup', listener);
                listener = null;
                pressedKeys.clear();
            }
        }
    };
})();


const $804439357c53744a$export$edaf19bb1d4a3d18 = {
    distance: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let p1 = {
            x: 100,
            y: 100
        };
        let p2 = {
            x: 300,
            y: 300
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, p1, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, p2, 'red');
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                start: p1,
                end: p2
            }, 'gray');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Distance',
                    $ee083671c43a5e14$export$9f17032d917177de(p1, p2)
                ],
                'Click to set point 1'
            ]);
        }
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, (pos)=>p1 = pos);
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>p2 = pos);
        draw(); // initial draw still needed
    },
    distanceSquared: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let p1 = {
            x: 100,
            y: 100
        };
        let p2 = {
            x: 300,
            y: 300
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, p1, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, p2, 'red');
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                start: p1,
                end: p2
            }, 'gray');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Distance',
                    $ee083671c43a5e14$export$9f17032d917177de(p1, p2)
                ],
                [
                    "Distance\xb2",
                    $ee083671c43a5e14$export$d019ad931e844842(p1, p2)
                ],
                'Click to set point 1'
            ]);
        }
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, (pos)=>p1 = pos);
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>p2 = pos);
        draw();
    },
    midpoint: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let p1 = {
            x: 100,
            y: 100
        };
        let p2 = {
            x: 300,
            y: 300
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, p1, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, p2, 'red');
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                start: p1,
                end: p2
            }, 'gray');
            const mid = $ee083671c43a5e14$export$f2e8a19be46147af(p1, p2);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, mid, 'green');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Midpoint',
                    mid
                ],
                'Click to set point 1'
            ]);
        }
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, (pos)=>p1 = pos);
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>p2 = pos);
        draw();
    },
    closest: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let points = [];
        let mousePos = {
            x: 0,
            y: 0
        };
        function generatePoints() {
            points = Array.from({
                length: 10
            }, ()=>({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height
                }));
        }
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            const closest = $ee083671c43a5e14$export$ff7f7c97cdce86e(mousePos, points);
            points.forEach((p)=>{
                (0, $086612735116fd75$export$654275d54901f10e)(ctx, p, p === closest ? 'red' : 'blue');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Mouse',
                    mousePos
                ],
                [
                    'Closest',
                    closest
                ],
                'Click to generate new points'
            ]);
        }
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, ()=>generatePoints());
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>mousePos = pos);
        generatePoints();
        draw();
    },
    isPointInCircle: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let circle = {
            x: 200,
            y: 200,
            radius: 50
        };
        let mousePos = {
            x: 0,
            y: 0
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            const isInside = $ee083671c43a5e14$export$489c99c59eb9ceb1(mousePos, circle);
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, circle, isInside ? 'green' : 'red');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, circle, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, mousePos, isInside ? 'green' : 'red');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Inside',
                    isInside
                ],
                [
                    'Circle',
                    circle
                ],
                'Click and drag to resize circle'
            ]);
        }
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>mousePos = pos);
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>circle = {
                    ...circle,
                    ...pos
                },
            onDrag: (pos)=>circle.radius = $ee083671c43a5e14$export$9f17032d917177de(circle, pos)
        });
        draw();
    },
    isPointInRectangle: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let rect = {
            x: 200,
            y: 200,
            width: 100,
            height: 100
        };
        let mousePos = {
            x: 0,
            y: 0
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            const isInside = $ee083671c43a5e14$export$4a253f8fe7a58694(mousePos, rect);
            (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, rect, isInside ? 'green' : 'red');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, mousePos, isInside ? 'green' : 'red');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Inside',
                    isInside
                ],
                [
                    'Rectangle',
                    rect
                ],
                'Click and drag to draw rectangle'
            ]);
        }
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>mousePos = pos);
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>rect = {
                    ...rect,
                    x: pos.x,
                    y: pos.y,
                    width: 0,
                    height: 0
                },
            onDrag: (pos)=>{
                rect.width = pos.x - rect.x;
                rect.height = pos.y - rect.y;
            }
        });
        draw();
    },
    isPointInLine: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let line = {
            start: {
                x: 100,
                y: 100
            },
            end: {
                x: 300,
                y: 300
            }
        };
        let mousePos = {
            x: 0,
            y: 0
        };
        let lineWidth = 10;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            const isInside = $ee083671c43a5e14$export$ff9583e4b2d0fe53(mousePos, line, lineWidth);
            const color = isInside ? 'green' : 'red';
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                ...line.start,
                radius: lineWidth / 2
            }, color, true);
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                ...line.end,
                radius: lineWidth / 2
            }, color, true);
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, line, color, lineWidth);
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Inside',
                    isInside
                ],
                [
                    'Line',
                    line
                ],
                [
                    'Line Width',
                    lineWidth
                ],
                'Click and drag to draw line',
                'Press + or - to adjust width'
            ]);
        }
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>mousePos = pos);
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>line.start = line.end = pos,
            onDrag: (pos)=>line.end = pos
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>lineWidth++,
            '-': ()=>lineWidth--
        });
        draw();
    },
    moveTowards: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let current = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        let target = {
            x: canvas.width / 2 + 100,
            y: canvas.height / 2
        };
        let maxDistance = 5;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, current, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, target, 'red');
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                start: current,
                end: target
            }, 'gray');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Current',
                    current
                ],
                [
                    'Target',
                    target
                ],
                [
                    'Distance',
                    $ee083671c43a5e14$export$9f17032d917177de(current, target)
                ],
                [
                    'Speed',
                    maxDistance
                ],
                'Move mouse to set target',
                'Use +/- to adjust speed'
            ]);
        }
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>target = pos);
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>maxDistance *= 1.2,
            '-': ()=>maxDistance /= 1.2
        });
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(draw, ()=>current = $ee083671c43a5e14$export$5145a8075501ee31(current, target, maxDistance));
    },
    interpolate: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let p1 = {
            x: 100,
            y: 100
        };
        let p2 = {
            x: 300,
            y: 300
        };
        let t = 0.5;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, p1, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, p2, 'red');
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                start: p1,
                end: p2
            }, 'gray');
            const interpolated = $ee083671c43a5e14$export$89e29e4ab65e70a9(p1, p2, t);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, interpolated, 'green');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Point 1',
                    p1
                ],
                [
                    'Point 2',
                    p2
                ],
                [
                    't (Interpolation)',
                    t.toFixed(2)
                ],
                [
                    'Interpolated',
                    interpolated
                ],
                'Click to set Point 1',
                'Move mouse to set Point 2',
                'Use +/- to adjust t'
            ]);
        }
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, (pos)=>p1 = pos);
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>p2 = pos);
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>t = Math.min(1, t + 0.05),
            '-': ()=>t = Math.max(0, t - 0.05)
        });
        draw();
    }
};


var $7d6e798d0a09cf0e$exports = {};

$parcel$export($7d6e798d0a09cf0e$exports, "degreesToRadians", () => $7d6e798d0a09cf0e$export$c9fcf1a7df975d78);
$parcel$export($7d6e798d0a09cf0e$exports, "radiansToDegrees", () => $7d6e798d0a09cf0e$export$c41dd2a8460d3196);
$parcel$export($7d6e798d0a09cf0e$exports, "radiansBetweenLines", () => $7d6e798d0a09cf0e$export$3a4b8e4b64134e7c);
$parcel$export($7d6e798d0a09cf0e$exports, "degreesBetweenLines", () => $7d6e798d0a09cf0e$export$ea8f9eb72b6b55d);
$parcel$export($7d6e798d0a09cf0e$exports, "radiansBetweenPoints", () => $7d6e798d0a09cf0e$export$96f15a967e7c135d);
$parcel$export($7d6e798d0a09cf0e$exports, "degreesBetweenPoints", () => $7d6e798d0a09cf0e$export$de2bf753b2214bd5);
$parcel$export($7d6e798d0a09cf0e$exports, "degreesBetweenAngles", () => $7d6e798d0a09cf0e$export$4db6634817520e36);
$parcel$export($7d6e798d0a09cf0e$exports, "radiansBetweenAngles", () => $7d6e798d0a09cf0e$export$8a7ae1f8cb144188);
$parcel$export($7d6e798d0a09cf0e$exports, "rotateAroundByRadians", () => $7d6e798d0a09cf0e$export$4c204ff3dcb25f97);
$parcel$export($7d6e798d0a09cf0e$exports, "rotateAroundByDegrees", () => $7d6e798d0a09cf0e$export$295b780a357000fd);
$parcel$export($7d6e798d0a09cf0e$exports, "rotateAngleTowardsRadians", () => $7d6e798d0a09cf0e$export$33ea901e4ef74ae7);
$parcel$export($7d6e798d0a09cf0e$exports, "rotateAngleTowardsDegrees", () => $7d6e798d0a09cf0e$export$6162db30a42a5821);

const $7d6e798d0a09cf0e$export$c9fcf1a7df975d78 = (degrees)=>{
    return degrees * Math.PI / 180;
};
const $7d6e798d0a09cf0e$export$c41dd2a8460d3196 = (radians)=>{
    return radians * 180 / Math.PI;
};
const $7d6e798d0a09cf0e$export$3a4b8e4b64134e7c = (line1, line2)=>{
    const dx1 = line1.end.x - line1.start.x;
    const dy1 = line1.end.y - line1.start.y;
    const dx2 = line2.end.x - line2.start.x;
    const dy2 = line2.end.y - line2.start.y;
    const dotProduct = dx1 * dx2 + dy1 * dy2;
    const magnitude1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    const magnitude2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
    const cosTheta = dotProduct / (magnitude1 * magnitude2);
    return Math.acos(cosTheta);
};
const $7d6e798d0a09cf0e$export$ea8f9eb72b6b55d = (line1, line2)=>{
    return $7d6e798d0a09cf0e$export$c41dd2a8460d3196($7d6e798d0a09cf0e$export$3a4b8e4b64134e7c(line1, line2));
};
const $7d6e798d0a09cf0e$export$96f15a967e7c135d = (p1, p2)=>{
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    return Math.atan2(dy, dx);
};
const $7d6e798d0a09cf0e$export$de2bf753b2214bd5 = (p1, p2)=>{
    return $7d6e798d0a09cf0e$export$c41dd2a8460d3196($7d6e798d0a09cf0e$export$96f15a967e7c135d(p1, p2));
};
const $7d6e798d0a09cf0e$export$4db6634817520e36 = (degrees1, degrees2)=>{
    const radians1 = $7d6e798d0a09cf0e$export$c9fcf1a7df975d78(degrees1);
    const radians2 = $7d6e798d0a09cf0e$export$c9fcf1a7df975d78(degrees2);
    const diff = radians2 - radians1;
    return $7d6e798d0a09cf0e$export$c41dd2a8460d3196(Math.atan2(Math.sin(diff), Math.cos(diff)));
};
const $7d6e798d0a09cf0e$export$8a7ae1f8cb144188 = (radians1, radians2)=>{
    const diff = radians2 - radians1;
    return Math.atan2(Math.sin(diff), Math.cos(diff));
};
const $7d6e798d0a09cf0e$export$4c204ff3dcb25f97 = (center, point, angleRadians)=>{
    const angleToTarget = $7d6e798d0a09cf0e$export$96f15a967e7c135d(center, point);
    const distanceToTarget = (0, $ee083671c43a5e14$export$9f17032d917177de)(center, point);
    return {
        x: center.x + Math.cos(angleToTarget + angleRadians) * distanceToTarget,
        y: center.y + Math.sin(angleToTarget + angleRadians) * distanceToTarget
    };
};
const $7d6e798d0a09cf0e$export$295b780a357000fd = (center, point, angleDegrees)=>{
    return $7d6e798d0a09cf0e$export$4c204ff3dcb25f97(center, point, $7d6e798d0a09cf0e$export$c9fcf1a7df975d78(angleDegrees));
};
const $7d6e798d0a09cf0e$export$33ea901e4ef74ae7 = (currentAngleRadians, targetAngleRadians, rotateAmountRadians)=>{
    // Normalize angles to [0, 2π]
    const current = (currentAngleRadians % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI);
    const normalizedTarget = (targetAngleRadians % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI);
    // Calculate shortest angular distance
    let diff = normalizedTarget - current;
    if (diff > Math.PI) diff -= 2 * Math.PI;
    if (diff < -Math.PI) diff += 2 * Math.PI;
    // Clamp rotation to the specified amount
    const rotation = Math.abs(diff) <= rotateAmountRadians ? diff : Math.sign(diff) * rotateAmountRadians;
    return current + rotation;
};
const $7d6e798d0a09cf0e$export$6162db30a42a5821 = (currentAngleDegrees, targetAngleDegrees, rotateAmountDegrees)=>{
    return $7d6e798d0a09cf0e$export$c41dd2a8460d3196($7d6e798d0a09cf0e$export$33ea901e4ef74ae7($7d6e798d0a09cf0e$export$c9fcf1a7df975d78(currentAngleDegrees), $7d6e798d0a09cf0e$export$c9fcf1a7df975d78(targetAngleDegrees), $7d6e798d0a09cf0e$export$c9fcf1a7df975d78(rotateAmountDegrees)));
};


const $97fc7d4a5f524dad$export$7f9972325ebfd559 = ()=>({
        x: 0,
        y: 0
    });
const $97fc7d4a5f524dad$export$e16d8520af44a096 = (v1, v2)=>({
        x: v1.x + v2.x,
        y: v1.y + v2.y
    });
const $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3 = (v1, v2)=>({
        x: v1.x - v2.x,
        y: v1.y - v2.y
    });
const $97fc7d4a5f524dad$export$dcdf75081b88279d = (v, scalar)=>({
        x: v.x * scalar,
        y: v.y * scalar
    });
const $97fc7d4a5f524dad$export$f24224f1c91d8156 = (v)=>Math.sqrt(v.x * v.x + v.y * v.y);
const $97fc7d4a5f524dad$export$411e9a7b4316b872 = (v1, v2)=>{
    const edge = $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(v2, v1);
    return $97fc7d4a5f524dad$export$a3295358bff77e({
        x: -edge.y,
        y: edge.x
    }); // Perpendicular to the edge
};
const $97fc7d4a5f524dad$export$a3295358bff77e = (v)=>{
    const len = $97fc7d4a5f524dad$export$f24224f1c91d8156(v);
    return len === 0 ? $97fc7d4a5f524dad$export$7f9972325ebfd559() : $97fc7d4a5f524dad$export$dcdf75081b88279d(v, 1 / len);
};
const $97fc7d4a5f524dad$export$7d15b64cf5a3a4c4 = (v, minLength, maxLength)=>{
    const len = $97fc7d4a5f524dad$export$f24224f1c91d8156(v);
    const clampedLength = Math.max(minLength, Math.min(maxLength, len));
    return $97fc7d4a5f524dad$export$dcdf75081b88279d($97fc7d4a5f524dad$export$a3295358bff77e(v), clampedLength);
};
const $97fc7d4a5f524dad$export$89e29e4ab65e70a9 = (start, end, t)=>({
        x: start.x + (end.x - start.x) * t,
        y: start.y + (end.y - start.y) * t
    });
const $97fc7d4a5f524dad$export$dcb617f3d34308fe = (start, end, point)=>{
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const dp = $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(point, start);
    return Math.max(0, Math.min(1, (dp.x * dx + dp.y * dy) / (dx * dx + dy * dy)));
};
const $97fc7d4a5f524dad$export$9debe8cffacea23 = (vector, normal)=>{
    // Using reflection formula R = V - 2(V·N)N
    const dotProduct = 2 * $97fc7d4a5f524dad$export$94132a0e348806d4(vector, normal); // 2(V·N)
    return {
        x: vector.x - dotProduct * normal.x,
        y: vector.y - dotProduct * normal.y
    };
};
const $97fc7d4a5f524dad$export$b1d53cea8aef9694 = (angleRadians, length)=>({
        x: Math.cos(angleRadians) * length,
        y: Math.sin(angleRadians) * length
    });
const $97fc7d4a5f524dad$export$e92f669ea83c5a35 = (angleDegrees, length)=>$97fc7d4a5f524dad$export$b1d53cea8aef9694(angleDegrees * Math.PI / 180, length);
const $97fc7d4a5f524dad$export$c78ecdc202171e36 = (v, angleRadians)=>{
    const cos = Math.cos(angleRadians);
    const sin = Math.sin(angleRadians);
    return {
        x: v.x * cos - v.y * sin,
        y: v.x * sin + v.y * cos
    };
};
const $97fc7d4a5f524dad$export$62f2d546c3c709dc = (v, angleDegrees)=>$97fc7d4a5f524dad$export$c78ecdc202171e36(v, angleDegrees * Math.PI / 180);
const $97fc7d4a5f524dad$export$94132a0e348806d4 = (v1, v2)=>v1.x * v2.x + v1.y * v2.y;
const $97fc7d4a5f524dad$export$4380c87abf28fdf = (v, newLength)=>{
    return $97fc7d4a5f524dad$export$dcdf75081b88279d($97fc7d4a5f524dad$export$a3295358bff77e(v), newLength);
};




const $1f98b464ed010556$export$4a0439d774561d41 = {
    degreesToRadians: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let degrees = 45;
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const radius = 100;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            // Draw center dot
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, center, 'black', 5);
            // Draw angle visualization
            const radians = $7d6e798d0a09cf0e$export$c9fcf1a7df975d78(degrees);
            (0, $086612735116fd75$export$bf8a3f9983094125)(ctx, center, radius, 0, radians, 'blue');
            // Draw lines at the end of the arc
            const normalEnd = $97fc7d4a5f524dad$export$e16d8520af44a096(center, {
                x: radius,
                y: 0
            });
            const angleEnd = $97fc7d4a5f524dad$export$e16d8520af44a096(center, $97fc7d4a5f524dad$export$b1d53cea8aef9694(radians, radius));
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                start: center,
                end: normalEnd
            }, 'blue');
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                start: center,
                end: angleEnd
            }, 'blue');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Degrees',
                    degrees
                ],
                [
                    'Radians',
                    radians
                ],
                'Use +/- to adjust angle'
            ]);
        }
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>degrees++,
            '-': ()=>degrees--
        });
        draw();
    },
    radiansToDegrees: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let radians = Math.PI / 4;
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const radius = 100;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            // Draw center dot
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, center, 'black', 5);
            // Draw angle visualization
            const degrees = $7d6e798d0a09cf0e$export$c41dd2a8460d3196(radians);
            (0, $086612735116fd75$export$bf8a3f9983094125)(ctx, center, radius, 0, radians, 'red');
            // Draw lines at the end of the arc
            const normalEnd = $97fc7d4a5f524dad$export$e16d8520af44a096(center, {
                x: radius,
                y: 0
            });
            const angleEnd = $97fc7d4a5f524dad$export$e16d8520af44a096(center, $97fc7d4a5f524dad$export$b1d53cea8aef9694(radians, radius));
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                start: center,
                end: normalEnd
            }, 'red');
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                start: center,
                end: angleEnd
            }, 'red');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Radians',
                    radians
                ],
                [
                    'Degrees',
                    degrees
                ],
                'Use +/- to adjust angle'
            ]);
        }
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>radians + Math.PI / 180,
            '-': ()=>radians -= Math.PI / 180
        });
        draw();
    },
    radiansBetweenLines: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let line1 = {
            start: {
                x: 400,
                y: 300
            },
            end: {
                x: 500,
                y: 300
            }
        };
        let line2 = {
            start: {
                x: 400,
                y: 300
            },
            end: {
                x: 500,
                y: 400
            }
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, line1, 'blue');
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, line2, 'red');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, line1.start, 'black');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Angle (rad)',
                    $7d6e798d0a09cf0e$export$3a4b8e4b64134e7c(line1, line2)
                ],
                'Drag endpoints to adjust lines'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>{
                const endpoint = $ee083671c43a5e14$export$ff7f7c97cdce86e(pos, [
                    line1.end,
                    line2.end
                ]);
                if (endpoint === line1.end) line1.end = pos;
                else line2.end = pos;
            },
            onDrag: (pos)=>{
                const endpoint = $ee083671c43a5e14$export$ff7f7c97cdce86e(pos, [
                    line1.end,
                    line2.end
                ]);
                if (endpoint === line1.end) line1.end = pos;
                else line2.end = pos;
            }
        });
        draw();
    },
    degreesBetweenLines: (canvas)=>{
        // Same as radiansBetweenLines but showing degrees
        const ctx = canvas.getContext('2d');
        let line1 = {
            start: {
                x: 400,
                y: 300
            },
            end: {
                x: 500,
                y: 300
            }
        };
        let line2 = {
            start: {
                x: 400,
                y: 300
            },
            end: {
                x: 500,
                y: 400
            }
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, line1, 'blue');
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, line2, 'red');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, line1.start, 'black');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Angle (deg)',
                    $7d6e798d0a09cf0e$export$ea8f9eb72b6b55d(line1, line2)
                ],
                'Drag endpoints to adjust lines'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>{
                const endpoint = $ee083671c43a5e14$export$ff7f7c97cdce86e(pos, [
                    line1.end,
                    line2.end
                ]);
                if (endpoint === line1.end) line1.end = pos;
                else line2.end = pos;
            },
            onDrag: (pos)=>{
                const endpoint = $ee083671c43a5e14$export$ff7f7c97cdce86e(pos, [
                    line1.end,
                    line2.end
                ]);
                if (endpoint === line1.end) line1.end = pos;
                else line2.end = pos;
            }
        });
        draw();
    },
    radiansBetweenPoints: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let center = {
            x: 400,
            y: 300
        };
        let target = {
            x: 500,
            y: 300
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, center, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, target, 'red');
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, center, target);
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Angle (rad)',
                    $7d6e798d0a09cf0e$export$96f15a967e7c135d(center, target)
                ],
                'Click to set center, move mouse for target'
            ]);
        }
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>target = pos);
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>center = pos,
            onDrag: (pos)=>center = pos
        });
        draw();
    },
    degreesBetweenPoints: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let center = {
            x: 400,
            y: 300
        };
        let target = {
            x: 500,
            y: 300
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, center, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, target, 'red');
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, center, target);
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Angle (deg)',
                    $7d6e798d0a09cf0e$export$de2bf753b2214bd5(center, target)
                ],
                'Click to set center, move mouse for target'
            ]);
        }
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>target = pos);
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>center = pos,
            onDrag: (pos)=>center = pos
        });
        draw();
    },
    degreesBetweenAngles: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let angle1 = 45;
        let angle2 = 90;
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const radius = 100;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            // Draw angle arrows
            const end1 = $97fc7d4a5f524dad$export$e16d8520af44a096(center, $97fc7d4a5f524dad$export$e92f669ea83c5a35(angle1, radius));
            const end2 = $97fc7d4a5f524dad$export$e16d8520af44a096(center, $97fc7d4a5f524dad$export$e92f669ea83c5a35(angle2, radius));
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, center, end1, 'blue');
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, center, end2, 'red');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Angle 1 (deg)',
                    angle1
                ],
                [
                    'Angle 2 (deg)',
                    angle2
                ],
                [
                    'Degrees Between',
                    $7d6e798d0a09cf0e$export$4db6634817520e36(angle1, angle2)
                ],
                'Use 1/2 to adjust angles'
            ]);
        }
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '1': ()=>angle1 = (angle1 + 15) % 360,
            '2': ()=>angle2 = (angle2 + 15) % 360
        });
        draw();
    },
    radiansBetweenAngles: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let angle1 = Math.PI / 4;
        let angle2 = Math.PI / 2;
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const radius = 100;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            // Draw angle arrows
            const end1 = $97fc7d4a5f524dad$export$e16d8520af44a096(center, $97fc7d4a5f524dad$export$b1d53cea8aef9694(angle1, radius));
            const end2 = $97fc7d4a5f524dad$export$e16d8520af44a096(center, $97fc7d4a5f524dad$export$b1d53cea8aef9694(angle2, radius));
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, center, end1, 'blue');
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, center, end2, 'red');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Angle 1 (rad)',
                    angle1
                ],
                [
                    'Angle 2 (rad)',
                    angle2
                ],
                [
                    'Radians Between',
                    $7d6e798d0a09cf0e$export$8a7ae1f8cb144188(angle1, angle2)
                ],
                'Use 1/2 to adjust angles'
            ]);
        }
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '1': ()=>angle1 = (angle1 + Math.PI / 6) % (Math.PI * 2),
            '2': ()=>angle2 = (angle2 + Math.PI / 6) % (Math.PI * 2)
        });
        draw();
    },
    rotateAroundByRadians: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let center = {
            x: 400,
            y: 300
        };
        let point = {
            x: 500,
            y: 300
        };
        const step = Math.PI / 180;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, center, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, point, 'red');
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, center, point);
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Center',
                    center
                ],
                [
                    'Point',
                    point
                ],
                [
                    'Angle (rad)',
                    $7d6e798d0a09cf0e$export$96f15a967e7c135d(center, point)
                ],
                'Click to set center, move mouse for point'
            ]);
        }
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>point = pos);
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, (pos)=>center = pos);
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(draw, ()=>point = $7d6e798d0a09cf0e$export$4c204ff3dcb25f97(center, point, step));
    },
    rotateAroundByDegrees: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let center = {
            x: 400,
            y: 300
        };
        let point = {
            x: 500,
            y: 300
        };
        const step = 1; // 1 degree per frame
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, center, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, point, 'red');
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, center, point);
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Center',
                    center
                ],
                [
                    'Point',
                    point
                ],
                [
                    'Angle (deg)',
                    $7d6e798d0a09cf0e$export$de2bf753b2214bd5(center, point)
                ],
                'Click to set center, move mouse for point'
            ]);
        }
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>point = pos);
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, (pos)=>center = pos);
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(draw, ()=>point = $7d6e798d0a09cf0e$export$295b780a357000fd(center, point, step));
    },
    rotateAngleTowardsRadians: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let currentAngle = 0;
        let center = {
            x: 400,
            y: 300
        };
        let target = {
            x: 500,
            y: 300
        };
        let step = Math.PI / 180 / 3;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, center, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, target, 'red');
            const arrowEnd = $97fc7d4a5f524dad$export$e16d8520af44a096(center, $97fc7d4a5f524dad$export$b1d53cea8aef9694(currentAngle, 100));
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, center, arrowEnd);
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Current Angle',
                    currentAngle
                ],
                [
                    'Target Angle',
                    $7d6e798d0a09cf0e$export$96f15a967e7c135d(center, target)
                ],
                [
                    'Speed',
                    step
                ],
                'Move mouse to change target',
                'Press +/- to adjust speed'
            ]);
        }
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>target = pos);
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>step *= 1.5,
            '-': ()=>step /= 1.5
        });
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(draw, ()=>currentAngle = $7d6e798d0a09cf0e$export$33ea901e4ef74ae7(currentAngle, $7d6e798d0a09cf0e$export$96f15a967e7c135d(center, target), step));
    },
    rotateAngleTowardsDegrees: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let currentAngle = 0;
        let center = {
            x: 400,
            y: 300
        };
        let target = {
            x: 500,
            y: 300
        };
        let step = .33;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, center, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, target, 'red');
            const arrowEnd = $97fc7d4a5f524dad$export$e16d8520af44a096(center, $97fc7d4a5f524dad$export$e92f669ea83c5a35(currentAngle, 100));
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, center, arrowEnd);
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Current Angle',
                    currentAngle
                ],
                [
                    'Target Angle',
                    $7d6e798d0a09cf0e$export$de2bf753b2214bd5(center, target)
                ],
                [
                    'Speed',
                    step
                ],
                'Move mouse to change target',
                'Press +/- to adjust speed'
            ]);
        }
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>target = pos);
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>step *= 1.5,
            '-': ()=>step /= 1.5
        });
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(draw, ()=>currentAngle = $7d6e798d0a09cf0e$export$6162db30a42a5821(currentAngle, $7d6e798d0a09cf0e$export$de2bf753b2214bd5(center, target), step));
    }
};



const $e0f9ecfe35f13ee3$export$717b54132acde7e2 = (line1, line2)=>{
    const { start: p1, end: p2 } = line1;
    const { start: p3, end: p4 } = line2;
    const denom = (p1.x - p2.x) * (p3.y - p4.y) - (p1.y - p2.y) * (p3.x - p4.x);
    if (denom === 0) return null; // Parallel lines
    const t = ((p1.x - p3.x) * (p3.y - p4.y) - (p1.y - p3.y) * (p3.x - p4.x)) / denom;
    const u = ((p1.x - p3.x) * (p1.y - p2.y) - (p1.y - p3.y) * (p1.x - p2.x)) / denom;
    if (t >= 0 && t <= 1 && u >= 0 && u <= 1) return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
    return null; // No intersection
};
const $e0f9ecfe35f13ee3$export$87a9ad0c3c05abf7 = (line, circle)=>{
    const { start: start, end: end } = line;
    const { x: cx, y: cy, radius: radius } = circle;
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const a = dx * dx + dy * dy;
    const b = 2 * (dx * (start.x - cx) + dy * (start.y - cy));
    const c = (start.x - cx) ** 2 + (start.y - cy) ** 2 - radius ** 2;
    const discriminant = b * b - 4 * a * c;
    if (discriminant < 0) return []; // No intersection
    const t1 = (-b - Math.sqrt(discriminant)) / (2 * a);
    const t2 = (-b + Math.sqrt(discriminant)) / (2 * a);
    const points = [];
    if (t1 >= 0 && t1 <= 1) points.push({
        x: start.x + t1 * dx,
        y: start.y + t1 * dy
    });
    if (t2 >= 0 && t2 <= 1) points.push({
        x: start.x + t2 * dx,
        y: start.y + t2 * dy
    });
    return points;
};
const $e0f9ecfe35f13ee3$export$1064a8e0d217f0ed = (line, rect)=>{
    const { x: x, y: y, width: width, height: height } = rect;
    const rectLines = [
        {
            start: {
                x: x,
                y: y
            },
            end: {
                x: x + width,
                y: y
            }
        },
        {
            start: {
                x: x + width,
                y: y
            },
            end: {
                x: x + width,
                y: y + height
            }
        },
        {
            start: {
                x: x + width,
                y: y + height
            },
            end: {
                x: x,
                y: y + height
            }
        },
        {
            start: {
                x: x,
                y: y + height
            },
            end: {
                x: x,
                y: y
            }
        }
    ];
    const intersections = [];
    rectLines.forEach((rectLine)=>{
        const intersection = $e0f9ecfe35f13ee3$export$717b54132acde7e2(line, rectLine);
        if (intersection) intersections.push(intersection);
    });
    return intersections;
};
const $e0f9ecfe35f13ee3$export$8e4f20627449cf66 = (circle1, circle2)=>{
    const d = (0, $ee083671c43a5e14$export$9f17032d917177de)(circle1, circle2);
    const overlap = circle1.radius + circle2.radius - d;
    return overlap > 0 ? overlap : 0; // Return overlap depth or 0 if no overlap
};
const $e0f9ecfe35f13ee3$export$e90bccbb88aa9786 = (rect1, rect2)=>{
    const x = Math.max(rect1.x, rect2.x);
    const y = Math.max(rect1.y, rect2.y);
    const width = Math.min(rect1.x + rect1.width, rect2.x + rect2.width) - x;
    const height = Math.min(rect1.y + rect1.height, rect2.y + rect2.height) - y;
    if (width > 0 && height > 0) return {
        x: x,
        y: y,
        width: width,
        height: height
    };
    return null; // No intersection
};









var $5dda501f4a9774dc$exports = {};

$parcel$export($5dda501f4a9774dc$exports, "applyForce", () => $5dda501f4a9774dc$export$da81038170e85b8c);
$parcel$export($5dda501f4a9774dc$exports, "applyDamping", () => $5dda501f4a9774dc$export$da1fe76f9b6a25f);
$parcel$export($5dda501f4a9774dc$exports, "applyTorque", () => $5dda501f4a9774dc$export$a7d88964434daaec);
$parcel$export($5dda501f4a9774dc$exports, "applyAngleForce", () => $5dda501f4a9774dc$export$3ffb1581bff1af41);
$parcel$export($5dda501f4a9774dc$exports, "collide", () => $5dda501f4a9774dc$export$98e6d07575f46913);
$parcel$export($5dda501f4a9774dc$exports, "separate", () => $5dda501f4a9774dc$export$709f6946f4e97408);
$parcel$export($5dda501f4a9774dc$exports, "repel", () => $5dda501f4a9774dc$export$168bb2ff78cb66b4);
$parcel$export($5dda501f4a9774dc$exports, "fluid", () => $5dda501f4a9774dc$export$86e87f677abfca4b);
$parcel$export($5dda501f4a9774dc$exports, "boids", () => $5dda501f4a9774dc$export$fbe21c35773c13ce);


const $5dda501f4a9774dc$export$da81038170e85b8c = (vector, force, scaler = 1)=>{
    vector.x += force.x * scaler;
    vector.y += force.y * scaler;
};
const $5dda501f4a9774dc$export$da1fe76f9b6a25f = (vector, damping)=>{
    vector.x *= 1 - damping;
    vector.y *= 1 - damping;
};
const $5dda501f4a9774dc$export$a7d88964434daaec = (angularVelocity, torque, scaler = 1)=>{
    return angularVelocity + torque * scaler;
};
const $5dda501f4a9774dc$export$3ffb1581bff1af41 = (vector, angle, force, scaler = 1)=>{
    $5dda501f4a9774dc$export$da81038170e85b8c(vector, (0, $97fc7d4a5f524dad$export$b1d53cea8aef9694)(angle, force), scaler);
};
const $5dda501f4a9774dc$export$98e6d07575f46913 = (obj1, obj2, restitution = 0.9, resolveOverlapMode = 'separate')=>{
    const normal = (0, $97fc7d4a5f524dad$export$a3295358bff77e)((0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(obj2.position, obj1.position));
    const relativeVelocity = (0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(obj2.velocity, obj1.velocity);
    // Check if objects are moving toward each other
    const velocityAlongNormal = (0, $97fc7d4a5f524dad$export$94132a0e348806d4)(relativeVelocity, normal);
    if (velocityAlongNormal <= 0) {
        // Calculate impulse
        const impulseMagnitude = -(1 + restitution) * velocityAlongNormal;
        const impulse = impulseMagnitude / (1 / obj1.mass + 1 / obj2.mass);
        // Apply impulse
        const impulseVector = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(normal, impulse);
        obj1.velocity = (0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(obj1.velocity, (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(impulseVector, 1 / obj1.mass));
        obj2.velocity = (0, $97fc7d4a5f524dad$export$e16d8520af44a096)(obj2.velocity, (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(impulseVector, 1 / obj2.mass));
    }
    // Handle overlap resolution based on mode
    if (resolveOverlapMode === 'separate') $5dda501f4a9774dc$export$709f6946f4e97408(obj1, obj2);
    else if (resolveOverlapMode === 'repel') $5dda501f4a9774dc$export$168bb2ff78cb66b4(obj1, obj2);
};
const $5dda501f4a9774dc$export$709f6946f4e97408 = (obj1, obj2)=>{
    const normal = (0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(obj2.position, obj1.position);
    const dist = (0, $ee083671c43a5e14$export$9f17032d917177de)(obj1.position, obj2.position);
    // Check if there is overlap
    const overlap = obj1.radius + obj2.radius - dist;
    if (overlap <= 0) return; // No overlap
    // Handle case where positions are identical
    const direction = dist === 0 ? {
        x: 1,
        y: 0
    } : (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(normal, 1 / dist);
    // Calculate the correction vector
    const totalMass = obj1.mass + obj2.mass;
    const correction = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(direction, overlap);
    // Distribute the correction based on the masses
    const obj1Correction = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(correction, obj2.mass / totalMass);
    const obj2Correction = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(correction, obj1.mass / totalMass);
    // Adjust the positions of the objects
    obj1.position = (0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(obj1.position, obj1Correction);
    obj2.position = (0, $97fc7d4a5f524dad$export$e16d8520af44a096)(obj2.position, obj2Correction);
};
const $5dda501f4a9774dc$export$168bb2ff78cb66b4 = (obj1, obj2, strength = 1)=>{
    const normal = (0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(obj2.position, obj1.position);
    const dist = (0, $ee083671c43a5e14$export$9f17032d917177de)(obj1.position, obj2.position);
    const overlap = obj1.radius + obj2.radius - dist;
    // Only apply repulsion if overlapping
    if (overlap <= 0 || dist === 0) return;
    // Normalize the direction vector
    const direction = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(normal, 1 / dist);
    // Calculate repulsion force based on overlap and scale by strength
    const repulsionForce = overlap * strength;
    // Calculate repulsion force proportional to mass difference
    const totalMass = obj1.mass + obj2.mass;
    const obj1Strength = obj2.mass / totalMass * repulsionForce;
    const obj2Strength = obj1.mass / totalMass * repulsionForce;
    // Apply repulsion forces to velocities
    obj1.velocity = (0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(obj1.velocity, (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(direction, obj1Strength));
    obj2.velocity = (0, $97fc7d4a5f524dad$export$e16d8520af44a096)(obj2.velocity, (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(direction, obj2Strength));
};
const $5dda501f4a9774dc$export$86e87f677abfca4b = (particles, { smoothingRadius: smoothingRadius = 30, stiffness: stiffness = 50, restDensity: restDensity = 1, viscosity: viscosity = 0.1 } = {})=>{
    const forces = particles.map(()=>({
            x: 0,
            y: 0
        }));
    const gridSize = smoothingRadius; // Size of each grid cell
    const grid = {};
    // Helper to compute grid key
    const getGridKey = (x, y)=>`${Math.floor(x / gridSize)},${Math.floor(y / gridSize)}`;
    // Populate the grid
    particles.forEach((p)=>{
        const key = getGridKey(p.position.x, p.position.y);
        if (!grid[key]) grid[key] = [];
        grid[key].push(p);
    });
    // Calculate densities
    particles.forEach((p)=>{
        p.density = 0;
        const key = getGridKey(p.position.x, p.position.y);
        // Check neighboring cells
        const [gx, gy] = key.split(',').map(Number);
        for(let dx = -1; dx <= 1; dx++)for(let dy = -1; dy <= 1; dy++){
            const neighborKey = `${gx + dx},${gy + dy}`;
            const neighbors = grid[neighborKey] || [];
            neighbors.forEach((neighbor)=>{
                const dist = Math.sqrt((0, $ee083671c43a5e14$export$d019ad931e844842)(p.position, neighbor.position));
                if (dist < smoothingRadius) p.density += neighbor.mass * (1 - dist / smoothingRadius);
            });
        }
        // Calculate pressure from density
        p.pressure = stiffness * (p.density - restDensity);
    });
    // Calculate forces
    particles.forEach((p, i)=>{
        const key = getGridKey(p.position.x, p.position.y);
        // Check neighboring cells
        const [gx, gy] = key.split(',').map(Number);
        for(let dx = -1; dx <= 1; dx++)for(let dy = -1; dy <= 1; dy++){
            const neighborKey = `${gx + dx},${gy + dy}`;
            const neighbors = grid[neighborKey] || [];
            neighbors.forEach((neighbor)=>{
                if (p === neighbor) return;
                const dist = (0, $ee083671c43a5e14$export$9f17032d917177de)(p.position, neighbor.position);
                if (dist < smoothingRadius) {
                    // Direction from p to neighbor
                    const dir = (0, $97fc7d4a5f524dad$export$a3295358bff77e)((0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(neighbor.position, p.position));
                    // Pressure force (repels particles in compressed regions)
                    const pressureForce = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(dir, -(p.pressure + neighbor.pressure) * (1 - dist / smoothingRadius) / (2 * p.density * neighbor.density));
                    // Viscosity force (averages out velocities)
                    const relativeVel = (0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(neighbor.velocity, p.velocity);
                    const viscosityForce = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(relativeVel, viscosity * (1 - dist / smoothingRadius) / (p.density * neighbor.density));
                    forces[i] = (0, $97fc7d4a5f524dad$export$e16d8520af44a096)(forces[i], (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)((0, $97fc7d4a5f524dad$export$e16d8520af44a096)(pressureForce, viscosityForce), p.mass * neighbor.mass));
                }
            });
        }
    });
    return forces;
};
const $5dda501f4a9774dc$export$fbe21c35773c13ce = (boids, rules = {})=>{
    const { separationRadius: separationRadius = 25, alignmentRadius: alignmentRadius = 50, cohesionRadius: cohesionRadius = 50, separationWeight: separationWeight = 1, alignmentWeight: alignmentWeight = 1, cohesionWeight: cohesionWeight = 1, maxSpeed: maxSpeed = 10 } = rules;
    return boids.map((boid, i)=>{
        let separation = {
            x: 0,
            y: 0
        };
        let alignment = {
            x: 0,
            y: 0
        };
        let cohesion = {
            x: 0,
            y: 0
        };
        let neighborCount = 0;
        // Calculate forces from all neighbors
        boids.forEach((other, j)=>{
            if (i === j) return;
            const dist = (0, $ee083671c43a5e14$export$9f17032d917177de)(boid.position, other.position);
            // Separation - avoid crowding
            if (dist < separationRadius) {
                const away = (0, $97fc7d4a5f524dad$export$a3295358bff77e)((0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(boid.position, other.position));
                separation = (0, $97fc7d4a5f524dad$export$e16d8520af44a096)(separation, (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(away, 1 / Math.max(dist, 0.1)));
            }
            // Alignment and Cohesion
            if (dist < alignmentRadius) {
                alignment = (0, $97fc7d4a5f524dad$export$e16d8520af44a096)(alignment, other.velocity);
                cohesion = (0, $97fc7d4a5f524dad$export$e16d8520af44a096)(cohesion, other.position);
                neighborCount++;
            }
        });
        // Average and scale forces
        let force = {
            x: 0,
            y: 0
        };
        if (neighborCount > 0) {
            // Normalize separation
            if (separation.x !== 0 || separation.y !== 0) separation = (0, $97fc7d4a5f524dad$export$a3295358bff77e)(separation);
            // Average alignment and cohesion
            alignment = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(alignment, 1 / neighborCount);
            cohesion = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(cohesion, 1 / neighborCount);
            // Move toward center of neighbors
            cohesion = (0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(cohesion, boid.position);
            // Normalize forces
            if (alignment.x !== 0 || alignment.y !== 0) alignment = (0, $97fc7d4a5f524dad$export$a3295358bff77e)(alignment);
            if (cohesion.x !== 0 || cohesion.y !== 0) cohesion = (0, $97fc7d4a5f524dad$export$a3295358bff77e)(cohesion);
            // Combine forces with weights
            force = (0, $97fc7d4a5f524dad$export$e16d8520af44a096)((0, $97fc7d4a5f524dad$export$e16d8520af44a096)((0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(separation, separationWeight), (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(alignment, alignmentWeight)), (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(cohesion, cohesionWeight));
        }
        // Clamp to max speed
        if (maxSpeed > 0) {
            const speed = Math.sqrt(force.x * force.x + force.y * force.y);
            if (speed > maxSpeed) force = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(force, maxSpeed / speed);
        }
        return force;
    });
};






class $e80cf0db060d44c4$export$324e885649fee72 {
    static{
        /** Default downward gravity for 2D side-view games */ this.DOWNWARD_GRAVITY = {
            x: 0,
            y: 980
        };
    }
    constructor(props = {}){
        /** General Properties (useful in all scenarios) */ this.position = {
            x: 0,
            y: 0
        } // Current position in world space
        ;
        this.velocity = $97fc7d4a5f524dad$export$7f9972325ebfd559() // Current movement speed & direction
        ;
        this.acceleration = $97fc7d4a5f524dad$export$7f9972325ebfd559() // Current change in velocity
        ;
        this.mass = 1 // Mass affects force response & collisions
        ;
        this.radius = 0 // Collision radius
        ;
        this.elasticity = 0.8 // Bounce factor (0 = stop, 1 = perfect bounce)
        ;
        this.collisionOverlapResolution = 'separate' // Overlap resolution mode
        ;
        this.minSpeed = 0 // Velocity below this will be set to zero
        ;
        /** Top-Down Properties (for top-down games like tanks, racing) */ this.angle = 0 // Rotation angle in radians
        ;
        this.angularVelocity = 0 // Speed of rotation
        ;
        this.angularDrag = 0 // Rotation damping
        ;
        this.friction = 0 // Ground friction (0 = slide forever, 1 = instant stop)
        ;
        /** Side-View Properties (for platformers, physics games) */ this.gravity = $97fc7d4a5f524dad$export$7f9972325ebfd559() // Gravity force vector
        ;
        this.drag = 0 // Air drag (0 = none, 1 = instant stop)
        ;
        Object.assign(this, props);
    }
    update(deltaTime) {
        // Apply gravity directly as acceleration (no mass needed)
        $5dda501f4a9774dc$export$da81038170e85b8c(this.acceleration, this.gravity);
        // Apply ground friction for top-down movement
        if (this.friction > 0) $5dda501f4a9774dc$export$da1fe76f9b6a25f(this.velocity, this.friction);
        // Apply air resistance for side-view movement
        if (this.drag > 0) $5dda501f4a9774dc$export$da1fe76f9b6a25f(this.velocity, this.drag);
        // Update velocity with acceleration
        $5dda501f4a9774dc$export$da81038170e85b8c(this.velocity, this.acceleration, deltaTime);
        // Clamp velocity to minSpeed and maxSpeed if set
        const speed = $97fc7d4a5f524dad$export$f24224f1c91d8156(this.velocity);
        if (this.maxSpeed !== undefined && speed > this.maxSpeed) this.velocity = $97fc7d4a5f524dad$export$dcdf75081b88279d($97fc7d4a5f524dad$export$a3295358bff77e(this.velocity), this.maxSpeed);
        if (speed < this.minSpeed) this.velocity = $97fc7d4a5f524dad$export$7f9972325ebfd559(); // Zero the velocity if below minSpeed
        // Update position with velocity
        $5dda501f4a9774dc$export$da81038170e85b8c(this.position, this.velocity, deltaTime);
        // Update angle with angular velocity
        this.angle += this.angularVelocity * deltaTime;
        // Apply angular drag
        if (this.angularDrag > 0) this.angularVelocity = $5dda501f4a9774dc$export$a7d88964434daaec(this.angularVelocity, this.angularVelocity, 1 / this.mass);
        // Reset forces
        this.acceleration = $97fc7d4a5f524dad$export$7f9972325ebfd559();
        this.angularVelocity = 0;
    }
    /**
   * Applies a continuous force that affects acceleration over time
   * Example: Gravity, engine thrust, wind
   * @param force The force vector to apply
   */ applyForce(force) {
        $5dda501f4a9774dc$export$da81038170e85b8c(this.acceleration, force, 1 / this.mass);
    }
    /**
   * Applies an instant change in velocity
   * Example: Collision impact, jump, explosion knockback
   * @param impulse The impulse vector (mass * velocity change)
   */ applyImpulse(impulse) {
        $5dda501f4a9774dc$export$da81038170e85b8c(this.velocity, impulse, 1 / this.mass);
    }
    /**
   * Applies a continuous rotational force
   * Example: Steering torque, wind rotation
   */ applyTorque(torque) {
        this.angularVelocity = $5dda501f4a9774dc$export$a7d88964434daaec(this.angularVelocity, torque, 1 / this.mass);
    }
    /**
   * Applies a continuous forward force in the direction of angle
   * Example: Rocket engine, car acceleration
   */ thrust(force, angle = this.angle) {
        $5dda501f4a9774dc$export$3ffb1581bff1af41(this.acceleration, angle, force, this.mass);
    }
    /**
   * Points the body towards a target point
   */ pointAt(target) {
        this.angle = (0, $7d6e798d0a09cf0e$export$96f15a967e7c135d)(this.position, target);
    }
    /**
   * Gradually rotates the body towards a target point at a specified rotation speed.
   * @param target The target point to rotate towards.
   * @param rotationSpeed The maximum rotation speed in radians per second.
   * @param deltaTime The time step for the rotation.
   */ pointTowards(target, rotationSpeed) {
        const targetAngle = (0, $7d6e798d0a09cf0e$export$96f15a967e7c135d)(this.position, target);
        this.angle = (0, $7d6e798d0a09cf0e$export$33ea901e4ef74ae7)(this.angle, targetAngle, rotationSpeed);
    }
    collideWithBody(other) {
        if (this === other) return false; // Ignore self-collision
        // Check if bodies are overlapping
        const dist = (0, $ee083671c43a5e14$export$9f17032d917177de)(other.position, this.position);
        if (dist > this.radius + other.radius) return false;
        // Calculate bounciness from combined restitution (multiply elasticities)
        const restitution = this.elasticity * other.elasticity;
        // Resolve collision using physics library
        $5dda501f4a9774dc$export$98e6d07575f46913(this, other, restitution, this.collisionOverlapResolution);
        return true;
    }
    collideWithSurface(point, normal) {
        // Normalize the normal vector
        const n = $97fc7d4a5f524dad$export$a3295358bff77e(normal);
        // Calculate penetration (negative means penetrating)
        const d = $97fc7d4a5f524dad$export$94132a0e348806d4($97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(this.position, point), n);
        if (d >= this.radius) return;
        // Move out of surface by remaining distance
        this.position = $97fc7d4a5f524dad$export$e16d8520af44a096(this.position, $97fc7d4a5f524dad$export$dcdf75081b88279d(n, this.radius - d));
        // Apply reflection with elasticity
        this.velocity = $97fc7d4a5f524dad$export$dcdf75081b88279d($97fc7d4a5f524dad$export$9debe8cffacea23(this.velocity, n), this.elasticity);
    }
    // Getters and Setters for x position
    get x() {
        return this.position.x;
    }
    set x(value) {
        this.position.x = value;
    }
    // Getters and Setters for y position
    get y() {
        return this.position.y;
    }
    set y(value) {
        this.position.y = value;
    }
    get speed() {
        return $97fc7d4a5f524dad$export$f24224f1c91d8156(this.velocity);
    }
    set speed(value) {
        if (Math.abs(value) < this.minSpeed) this.velocity = $97fc7d4a5f524dad$export$7f9972325ebfd559(); // Zero the velocity if below minSpeed
        else this.velocity = $97fc7d4a5f524dad$export$4380c87abf28fdf(this.velocity, value);
    }
}




const $fdcbb30aaeabb80a$export$10b0d1ad557ec395 = {
    getLineIntersection: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let line1 = {
            start: {
                x: 100,
                y: 100
            },
            end: {
                x: 300,
                y: 300
            }
        };
        let line2 = {
            start: {
                x: 100,
                y: 300
            },
            end: {
                x: 300,
                y: 100
            }
        };
        let draggedPoint = null;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, line1, 'blue');
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, line2, 'red');
            const p = $e0f9ecfe35f13ee3$export$717b54132acde7e2(line1, line2);
            if (p) (0, $086612735116fd75$export$654275d54901f10e)(ctx, p, 'green');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Intersection',
                    p || 'None'
                ],
                'Drag endpoints to adjust the lines'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>{
                draggedPoint = (0, $ee083671c43a5e14$exports).closest(pos, [
                    line1.start,
                    line1.end,
                    line2.start,
                    line2.end
                ]);
            },
            onDrag: (pos)=>{
                if (draggedPoint) {
                    draggedPoint.x = pos.x;
                    draggedPoint.y = pos.y;
                }
            },
            onEnd: ()=>{
                draggedPoint = null;
            }
        });
        draw();
    },
    getLineCircleIntersections: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let lineSegment = {
            start: {
                x: 100,
                y: 100
            },
            end: {
                x: 300,
                y: 300
            }
        };
        let circle = {
            x: 200,
            y: 200,
            radius: 50
        };
        let draggedPoint = null;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, lineSegment, 'blue');
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, circle, 'red');
            const intersections = $e0f9ecfe35f13ee3$export$87a9ad0c3c05abf7(lineSegment, circle);
            intersections.forEach((p)=>(0, $086612735116fd75$export$654275d54901f10e)(ctx, p, 'green'));
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                ...intersections?.map((p)=>[
                        'Intersection',
                        p
                    ]) ?? [],
                'Drag endpoints or circle to adjust'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>{
                const points = [
                    lineSegment.start,
                    lineSegment.end,
                    circle
                ];
                draggedPoint = (0, $ee083671c43a5e14$exports).closest(pos, points);
            },
            onDrag: (pos)=>{
                if (draggedPoint) {
                    draggedPoint.x = pos.x;
                    draggedPoint.y = pos.y;
                }
            },
            onEnd: ()=>{
                draggedPoint = null;
            }
        });
        draw();
    },
    getLineRectIntersections: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let lineSegment = {
            start: {
                x: 100,
                y: 100
            },
            end: {
                x: 300,
                y: 300
            }
        };
        let rect = {
            x: 150,
            y: 150,
            width: 100,
            height: 100
        };
        let draggedPoint = null;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, lineSegment, 'blue');
            (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, rect, 'red');
            const intersections = $e0f9ecfe35f13ee3$export$1064a8e0d217f0ed(lineSegment, rect);
            intersections.forEach((p)=>(0, $086612735116fd75$export$654275d54901f10e)(ctx, p, 'green'));
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                ...intersections?.map((p)=>[
                        'Intersection',
                        p
                    ]) ?? [],
                'Drag endpoints or rectangle to adjust'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>{
                const points = [
                    lineSegment.start,
                    lineSegment.end,
                    rect
                ];
                draggedPoint = (0, $ee083671c43a5e14$exports).closest(pos, points);
            },
            onDrag: (pos)=>{
                if (draggedPoint) {
                    draggedPoint.x = pos.x;
                    draggedPoint.y = pos.y;
                }
            },
            onEnd: ()=>{
                draggedPoint = null;
            }
        });
        draw();
    },
    getCircleOverlap: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let circle1 = {
            x: 200,
            y: 200,
            radius: 100
        };
        let circle2 = {
            x: 300,
            y: 200,
            radius: 50
        };
        let draggedCircle = null;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, circle1, 'blue');
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, circle2, 'red');
            const overlap = $e0f9ecfe35f13ee3$export$8e4f20627449cf66(circle1, circle2);
            if (overlap > 0) {
                // Use getLineCircleIntersections to find overlap center
                const line = {
                    start: circle1,
                    end: circle2
                };
                const intersections = $e0f9ecfe35f13ee3$export$87a9ad0c3c05abf7(line, {
                    x: circle1.x,
                    y: circle1.y,
                    radius: circle1.radius - overlap / 2
                });
                if (intersections.length > 0) {
                    const overlapCenter = intersections[0];
                    (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                        x: overlapCenter.x,
                        y: overlapCenter.y,
                        radius: overlap / 2
                    }, 'green', true);
                }
            }
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Overlap Depth',
                    overlap
                ],
                'Drag circles to adjust'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>{
                const points = [
                    circle1,
                    circle2
                ];
                draggedCircle = (0, $ee083671c43a5e14$exports).closest(pos, points);
            },
            onDrag: (pos)=>{
                if (draggedCircle) {
                    draggedCircle.x = pos.x;
                    draggedCircle.y = pos.y;
                }
            },
            onEnd: ()=>{
                draggedCircle = null;
            }
        });
        draw();
    },
    getRectanglesIntersection: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let rect1 = {
            x: 100,
            y: 100,
            width: 150,
            height: 100
        };
        let rect2 = {
            x: 200,
            y: 150,
            width: 250,
            height: 150
        };
        let draggedRect = null;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, rect1, 'blue');
            (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, rect2, 'red');
            const intersectionRect = $e0f9ecfe35f13ee3$export$e90bccbb88aa9786(rect1, rect2);
            if (intersectionRect) (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, intersectionRect, 'green', true);
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Intersection',
                    intersectionRect || 'None'
                ],
                'Drag rectangles to adjust'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>{
                const points = [
                    rect1,
                    rect2
                ];
                draggedRect = (0, $ee083671c43a5e14$exports).closest(pos, points);
            },
            onDrag: (pos)=>{
                if (draggedRect) {
                    draggedRect.x = pos.x;
                    draggedRect.y = pos.y;
                }
            },
            onEnd: ()=>{
                draggedRect = null;
            }
        });
        draw();
    }
};





const $598db149d2af8004$export$f9d080264ca8206b = {
    zero: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        const v = $97fc7d4a5f524dad$export$7f9972325ebfd559();
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v, 'blue');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Vector',
                    v
                ],
                'Zero vector has no direction or length'
            ]);
        }
        draw();
    },
    add: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let v1 = {
            x: 100,
            y: 0
        };
        let v2 = {
            x: 0,
            y: 100
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v1, 'blue');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, v1, $97fc7d4a5f524dad$export$e16d8520af44a096(v1, v2), 'red');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, $97fc7d4a5f524dad$export$e16d8520af44a096(v1, v2), 'green');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Vector 1',
                    v1
                ],
                [
                    'Vector 2',
                    v2
                ],
                [
                    'Sum',
                    $97fc7d4a5f524dad$export$e16d8520af44a096(v1, v2)
                ],
                'Drag blue/red arrows to adjust vectors'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw,
            center: center
        }, {
            onDrag: (pos)=>{
                const end1 = $97fc7d4a5f524dad$export$e16d8520af44a096(origin, v1);
                const end2 = $97fc7d4a5f524dad$export$e16d8520af44a096(end1, v2);
                const closest = $ee083671c43a5e14$export$ff7f7c97cdce86e(pos, [
                    end1,
                    end2
                ]);
                if (closest === end1) v1 = $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(pos, origin);
                else v2 = $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(pos, end1);
            }
        });
        draw();
    },
    subtract: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let v1 = {
            x: 100,
            y: 0
        };
        let v2 = {
            x: 0,
            y: 100
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v1, 'blue');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v2, 'red');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(v1, v2), 'green');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Vector 1',
                    v1
                ],
                [
                    'Vector 2',
                    v2
                ],
                [
                    'Difference',
                    $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(v1, v2)
                ],
                'Drag blue/red arrows to adjust vectors'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw,
            center: center
        }, {
            onDrag: (pos)=>{
                const end1 = $97fc7d4a5f524dad$export$e16d8520af44a096(origin, v1);
                const end2 = $97fc7d4a5f524dad$export$e16d8520af44a096(origin, v2);
                const closest = $ee083671c43a5e14$export$ff7f7c97cdce86e(pos, [
                    end1,
                    end2
                ]);
                if (closest === end1) v1 = $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(pos, origin);
                else v2 = $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(pos, origin);
            }
        });
        draw();
    },
    scale: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let v = {
            x: 100,
            y: 0
        };
        let scale = 0.75;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v, 'blue');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, $97fc7d4a5f524dad$export$dcdf75081b88279d(v, scale), 'green');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Vector',
                    v
                ],
                [
                    'Scale',
                    scale
                ],
                [
                    'Result',
                    $97fc7d4a5f524dad$export$dcdf75081b88279d(v, scale)
                ],
                'Drag blue arrow to adjust vector',
                'Use +/- to adjust scale'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw,
            center: center
        }, {
            onDrag: (pos)=>v = pos
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>scale *= 1.1,
            '-': ()=>scale /= 1.1
        });
        draw();
    },
    length: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let v = {
            x: 100,
            y: 0
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v, 'blue');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Vector',
                    v
                ],
                [
                    'Length',
                    $97fc7d4a5f524dad$export$f24224f1c91d8156(v)
                ],
                'Drag arrow to adjust vector'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onDrag: (pos)=>v = $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(pos, center)
        });
        draw();
    },
    normal: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let p1 = {
            x: center.x - 100,
            y: center.y
        };
        let p2 = {
            x: center.x + 100,
            y: center.y
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            // Draw points and line
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, p1, 'blue');
            (0, $086612735116fd75$export$654275d54901f10e)(ctx, p2, 'red');
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                start: p1,
                end: p2
            }, 'gray');
            // Calculate and draw normal
            const normalVector = $97fc7d4a5f524dad$export$411e9a7b4316b872(p1, p2);
            const normalStart = $97fc7d4a5f524dad$export$89e29e4ab65e70a9(p1, p2, 0.5); // Midpoint
            const normalEnd = $97fc7d4a5f524dad$export$e16d8520af44a096(normalStart, $97fc7d4a5f524dad$export$dcdf75081b88279d(normalVector, 50));
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, normalStart, normalEnd, 'green');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Point 1',
                    p1
                ],
                [
                    'Point 2',
                    p2
                ],
                [
                    'Normal',
                    normalVector
                ],
                'Drag blue/red points to adjust'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onDrag: (pos)=>{
                const closest = $ee083671c43a5e14$export$ff7f7c97cdce86e(pos, [
                    p1,
                    p2
                ]);
                if (closest === p1) p1 = pos;
                else p2 = pos;
            }
        });
        draw();
    },
    normalize: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let v = {
            x: 100,
            y: 0
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v, 'blue');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, $97fc7d4a5f524dad$export$a3295358bff77e(v), 'green');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Vector',
                    v
                ],
                [
                    'Length',
                    $97fc7d4a5f524dad$export$f24224f1c91d8156(v)
                ],
                [
                    'Normalized',
                    $97fc7d4a5f524dad$export$a3295358bff77e(v)
                ],
                'Drag arrow to adjust vector'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw,
            center: center
        }, {
            onDrag: (pos)=>v = pos
        });
        draw();
    },
    clamp: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let v = {
            x: 100,
            y: 0
        };
        let minLength = 50;
        let maxLength = 100;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v, 'blue');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, $97fc7d4a5f524dad$export$7d15b64cf5a3a4c4(v, minLength, maxLength), 'green');
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                    x: 0,
                    y: 0,
                    radius: maxLength
                }, 'gray'); // Max length boundary
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                    x: 0,
                    y: 0,
                    radius: minLength
                }, 'lightgray'); // Min length boundary
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Vector',
                    v
                ],
                [
                    'Length',
                    $97fc7d4a5f524dad$export$f24224f1c91d8156(v)
                ],
                [
                    'Min Length',
                    minLength
                ],
                [
                    'Max Length',
                    maxLength
                ],
                'Drag arrow to adjust vector',
                'Use +/- to adjust max length',
                'Use [/] to adjust min length'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw,
            center: center
        }, {
            onDrag: (pos)=>v = pos
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>maxLength += 10,
            '-': ()=>maxLength = Math.max(minLength + 10, maxLength - 10),
            '[': ()=>minLength = Math.max(0, minLength - 10),
            ']': ()=>minLength = Math.min(maxLength - 10, minLength + 10)
        });
        draw();
    },
    interpolate: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let v1 = {
            x: -100,
            y: 0
        };
        let v2 = {
            x: 100,
            y: 0
        };
        let t = 0.5;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                const result = $97fc7d4a5f524dad$export$89e29e4ab65e70a9(v1, v2, t);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v1, 'blue');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v2, 'red');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, result, 'green');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Vector 1',
                    v1
                ],
                [
                    'Vector 2',
                    v2
                ],
                [
                    't',
                    t
                ],
                [
                    'Result',
                    $97fc7d4a5f524dad$export$89e29e4ab65e70a9(v1, v2, t)
                ],
                'Drag blue/red arrows to adjust vectors',
                'Use +/- to adjust t'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw,
            center: center
        }, {
            onDrag: (pos)=>{
                const closest = $ee083671c43a5e14$export$ff7f7c97cdce86e(pos, [
                    v1,
                    v2
                ]);
                closest.x = pos.x;
                closest.y = pos.y;
            }
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>t = Math.min(1, t + 0.1),
            '-': ()=>t = Math.max(0, t - 0.1)
        });
        draw();
    },
    interpolateInverse: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let v1 = {
            x: -100,
            y: 0
        };
        let v2 = {
            x: 100,
            y: 0
        };
        let p = {
            x: 0,
            y: 0
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                const t = $97fc7d4a5f524dad$export$dcb617f3d34308fe(v1, v2, p);
                const projected = $97fc7d4a5f524dad$export$89e29e4ab65e70a9(v1, v2, t);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v1, 'blue');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v2, 'red');
                (0, $086612735116fd75$export$654275d54901f10e)(ctx, p, 'green');
                (0, $086612735116fd75$export$654275d54901f10e)(ctx, projected, 'black');
                (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                    start: p,
                    end: projected
                }, 'gray');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Start',
                    v1
                ],
                [
                    'End',
                    v2
                ],
                [
                    'Point',
                    p
                ],
                [
                    't',
                    $97fc7d4a5f524dad$export$dcb617f3d34308fe(v1, v2, p)
                ],
                'Drag blue/red arrows for vectors',
                'Move mouse to test positions'
            ]);
        }
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw,
            center: center
        }, (pos)=>{
            p = pos;
        });
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw,
            center: center
        }, {
            onDrag: (pos)=>{
                const closest = $ee083671c43a5e14$export$ff7f7c97cdce86e(pos, [
                    v1,
                    v2
                ]);
                closest.x = pos.x;
                closest.y = pos.y;
            }
        });
        draw();
    },
    reflect: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let velocity = {
            x: 100,
            y: 100
        };
        let normal = $97fc7d4a5f524dad$export$b1d53cea8aef9694(0, 1);
        const rotateAmount = Math.PI / 12;
        let restitution = 1;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                const normalVec = $97fc7d4a5f524dad$export$dcdf75081b88279d($97fc7d4a5f524dad$export$a3295358bff77e(normal), 100);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, normalVec, 'blue');
                (0, $086612735116fd75$export$654275d54901f10e)(ctx, velocity, 'red');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, velocity, origin, 'red');
                const reflected = $97fc7d4a5f524dad$export$dcdf75081b88279d($97fc7d4a5f524dad$export$9debe8cffacea23(velocity, $97fc7d4a5f524dad$export$a3295358bff77e(normal)), restitution);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, reflected, 'green');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Normal',
                    normal
                ],
                [
                    'Velocity',
                    velocity
                ],
                [
                    'Restitution',
                    restitution
                ],
                [
                    'Reflected',
                    $97fc7d4a5f524dad$export$dcdf75081b88279d($97fc7d4a5f524dad$export$9debe8cffacea23(velocity, $97fc7d4a5f524dad$export$a3295358bff77e(normal)), restitution)
                ],
                'Drag red arrow to adjust incoming velocity',
                'Drag blue arrow to adjust surface normal',
                'Use +/- to adjust restitution'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw,
            center: center
        }, {
            onDrag: (pos)=>{
                const closest = $ee083671c43a5e14$export$ff7f7c97cdce86e(pos, [
                    velocity,
                    normal
                ]);
                if (closest === velocity) velocity = pos;
                else normal = $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(pos, origin);
            }
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>restitution = Math.min(2, restitution + 0.1),
            '-': ()=>restitution = Math.max(0, restitution - 0.1)
        });
        draw();
    },
    fromAngleRadians: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let angle = 0;
        let length = 100;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                const v = $97fc7d4a5f524dad$export$b1d53cea8aef9694(angle, length);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v, 'blue');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Angle (rad)',
                    angle
                ],
                [
                    'Length',
                    length
                ],
                [
                    'Vector',
                    $97fc7d4a5f524dad$export$b1d53cea8aef9694(angle, length)
                ],
                'Use +/- to adjust angle',
                'Use [/] to adjust length'
            ]);
        }
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>angle += Math.PI / 12,
            '-': ()=>angle -= Math.PI / 12,
            '[': ()=>length = Math.max(10, length - 10),
            ']': ()=>length += 10
        });
        draw();
    },
    fromAngleDegrees: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let angle = 0;
        let length = 100;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                const v = $97fc7d4a5f524dad$export$e92f669ea83c5a35(angle, length);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v, 'blue');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Angle (deg)',
                    angle
                ],
                [
                    'Length',
                    length
                ],
                [
                    'Vector',
                    $97fc7d4a5f524dad$export$e92f669ea83c5a35(angle, length)
                ],
                'Use +/- to adjust angle',
                'Use [/] to adjust length'
            ]);
        }
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>angle += 15,
            '-': ()=>angle -= 15,
            '[': ()=>length = Math.max(10, length - 10),
            ']': ()=>length += 10
        });
        draw();
    },
    rotateByRadians: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let v = {
            x: 100,
            y: 0
        };
        let angle = Math.PI / 4;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v, 'blue');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, $97fc7d4a5f524dad$export$c78ecdc202171e36(v, angle), 'green');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Vector',
                    v
                ],
                [
                    'Angle (rad)',
                    angle
                ],
                [
                    'Rotated',
                    $97fc7d4a5f524dad$export$c78ecdc202171e36(v, angle)
                ],
                'Drag blue arrow to adjust vector',
                'Use +/- to adjust angle'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw,
            center: center
        }, {
            onDrag: (pos)=>v = pos
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>angle += Math.PI / 12,
            '-': ()=>angle -= Math.PI / 12
        });
        draw();
    },
    rotateByDegrees: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let v = {
            x: 100,
            y: 0
        };
        let angle = 15;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v, 'blue');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, $97fc7d4a5f524dad$export$62f2d546c3c709dc(v, angle), 'green');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Vector',
                    v
                ],
                [
                    'Angle (deg)',
                    angle
                ],
                [
                    'Rotated',
                    $97fc7d4a5f524dad$export$62f2d546c3c709dc(v, angle)
                ],
                'Drag blue arrow to adjust vector',
                'Use +/- to adjust angle'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw,
            center: center
        }, {
            onDrag: (pos)=>v = pos
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>angle += 15,
            '-': ()=>angle -= 15
        });
        draw();
    },
    dot: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let v1 = {
            x: 100,
            y: 0
        };
        let v2 = {
            x: 0,
            y: 100
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v1, 'blue');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v2, 'red');
                const dotProduct = $97fc7d4a5f524dad$export$94132a0e348806d4(v1, v2);
                const projectionScale = dotProduct / ($97fc7d4a5f524dad$export$f24224f1c91d8156(v1) * $97fc7d4a5f524dad$export$f24224f1c91d8156(v2));
                const projection = $97fc7d4a5f524dad$export$dcdf75081b88279d(v2, projectionScale);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, projection, 'green');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Vector 1',
                    v1
                ],
                [
                    'Vector 2',
                    v2
                ],
                [
                    'Dot Product',
                    $97fc7d4a5f524dad$export$94132a0e348806d4(v1, v2)
                ],
                [
                    'Projection of v1 onto v2',
                    $97fc7d4a5f524dad$export$dcdf75081b88279d(v2, $97fc7d4a5f524dad$export$94132a0e348806d4(v1, v2) / $97fc7d4a5f524dad$export$f24224f1c91d8156(v2) ** 2)
                ],
                'Drag blue/red arrows to adjust vectors'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw,
            center: center
        }, {
            onDrag: (pos)=>{
                const closest = $ee083671c43a5e14$export$ff7f7c97cdce86e(pos, [
                    v1,
                    v2
                ]);
                closest.x = pos.x;
                closest.y = pos.y;
            }
        });
        draw();
    },
    resize: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const center = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        const origin = {
            x: 0,
            y: 0
        };
        let v = {
            x: 100,
            y: 50
        };
        let newLength = 150;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$712d35b7f1932be6)(ctx);
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, v, 'blue');
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, origin, $97fc7d4a5f524dad$export$4380c87abf28fdf(v, newLength), 'green');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Vector',
                    v
                ],
                [
                    'Original Length',
                    $97fc7d4a5f524dad$export$f24224f1c91d8156(v)
                ],
                [
                    'New Length',
                    newLength
                ],
                [
                    'Resized Vector',
                    $97fc7d4a5f524dad$export$4380c87abf28fdf(v, newLength)
                ],
                'Drag arrow to adjust vector',
                'Use +/- to adjust new length'
            ]);
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw,
            center: center
        }, {
            onDrag: (pos)=>v = pos
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>newLength += 10,
            '-': ()=>newLength = Math.max(10, newLength - 10)
        });
        draw();
    }
};








const $51a78989f62341bf$export$3ee404efaa54ac8a = {
    applyForce: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let position = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        let velocity = {
            x: 0,
            y: 0
        };
        let force = {
            x: 0.05,
            y: -0.03
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                ...position,
                radius: 10
            }, 'blue');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Position',
                    position
                ],
                [
                    'Velocity',
                    velocity
                ],
                [
                    'Force',
                    force
                ],
                'Click to reset position',
                'Use +/- to change force magnitude'
            ]);
        }
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(()=>{
            $5dda501f4a9774dc$export$da81038170e85b8c(velocity, force, 1);
            position.x += velocity.x;
            position.y += velocity.y;
        }, draw);
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, (pos)=>{
            position = {
                ...pos
            };
            velocity = {
                x: 0,
                y: 0
            };
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>{
                force.x *= 1.1;
                force.y *= 1.1;
            },
            '-': ()=>{
                force.x *= 0.9;
                force.y *= 0.9;
            }
        });
    },
    applyDamping: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let position = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        let velocity = {
            x: 5,
            y: -3
        };
        let damping = 0.05;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                ...position,
                radius: 10
            }, 'blue');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Position',
                    position
                ],
                [
                    'Velocity',
                    velocity
                ],
                [
                    'Damping',
                    damping
                ],
                'Click to reset position',
                'Use +/- to change damping amount'
            ]);
        }
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(()=>{
            $5dda501f4a9774dc$export$da1fe76f9b6a25f(velocity, damping);
            position.x += velocity.x;
            position.y += velocity.y;
        }, draw);
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, (pos)=>{
            position = {
                ...pos
            };
            velocity = {
                x: 5,
                y: -3
            };
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>{
                damping = Math.min(damping + 0.01, 1); // Cap damping at 1
            },
            '-': ()=>{
                damping = Math.max(damping - 0.01, 0); // Ensure damping is non-negative
            }
        });
    },
    applyTorque: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let angle = 0;
        let angularVelocity = 0;
        let torque = 0.1;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            const center = {
                x: canvas.width / 2,
                y: canvas.height / 2
            };
            const end = (0, $97fc7d4a5f524dad$export$b1d53cea8aef9694)(angle, 50);
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, center, (ctx)=>{
                (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                    start: {
                        x: 0,
                        y: 0
                    },
                    end: end
                }, 'blue', 2);
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Angle',
                    angle
                ],
                [
                    'Angular Velocity',
                    angularVelocity
                ],
                [
                    'Torque',
                    torque
                ],
                'Click to reset angle',
                'Use +/- to change torque amount'
            ]);
        }
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(()=>{
            angularVelocity = $5dda501f4a9774dc$export$a7d88964434daaec(angularVelocity, torque, 0.01);
            angle += angularVelocity;
        }, draw);
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, ()=>{
            angle = 0;
            angularVelocity = 0;
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>{
                torque = Math.min(torque + 0.01, 1); // Cap torque at 1
            },
            '-': ()=>{
                torque = Math.max(torque - 0.01, 0); // Ensure torque is non-negative
            }
        });
    },
    applyAngleForce: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let position = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        let velocity = {
            x: 0,
            y: 0
        };
        let forceMagnitude = 0.1;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                ...position,
                radius: 10
            }, 'blue');
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Position',
                    position
                ],
                [
                    'Velocity',
                    velocity
                ],
                [
                    'Force Magnitude',
                    forceMagnitude
                ],
                'Press to apply force away from mouse',
                'Use +/- to change force magnitude'
            ]);
        }
        let isMouseDown = false;
        let mousePos = {
            x: 0,
            y: 0
        };
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(()=>{
            if (isMouseDown) {
                const angle = (0, $7d6e798d0a09cf0e$export$96f15a967e7c135d)(mousePos, position);
                $5dda501f4a9774dc$export$3ffb1581bff1af41(velocity, angle, forceMagnitude, 1);
            }
            position.x += velocity.x;
            position.y += velocity.y;
            // Reset position if it leaves the canvas bounds
            if (position.x < 0 || position.x > canvas.width || position.y < 0 || position.y > canvas.height) {
                position = {
                    x: canvas.width / 2,
                    y: canvas.height / 2
                };
                velocity = {
                    x: 0,
                    y: 0
                };
            }
        }, draw);
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>{
                isMouseDown = true;
                mousePos = pos;
            },
            onDrag: (pos)=>mousePos = pos,
            onEnd: (pos)=>{
                mousePos = pos;
                isMouseDown = false;
            }
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>forceMagnitude += .01,
            '-': ()=>forceMagnitude -= .01
        });
    },
    collide: (canvas)=>{
        const ctx = canvas.getContext('2d');
        let obj1 = {
            position: {
                x: 200,
                y: 200
            },
            velocity: {
                x: 0,
                y: 0
            },
            mass: 1,
            radius: 20
        };
        let obj2 = {
            position: {
                x: 400,
                y: 200
            },
            velocity: {
                x: 0,
                y: 0
            },
            mass: 1,
            radius: 20
        };
        let isSimulationRunning = false;
        let draggedPosition = null;
        const init1 = {
            start: {
                x: 200,
                y: 300
            },
            end: {
                x: 250,
                y: 320
            }
        };
        const init2 = {
            start: {
                x: 400,
                y: 300
            },
            end: {
                x: 330,
                y: 310
            }
        };
        start();
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            // Update object radii based on mass
            obj1.radius = obj1.mass * 20;
            obj2.radius = obj2.mass * 20;
            // Draw initial circles and velocity arrows
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                x: init1.start.x,
                y: init1.start.y,
                radius: obj1.radius
            }, 'gray', false);
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, init1.start, init1.end, 'gray');
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                x: init2.start.x,
                y: init2.start.y,
                radius: obj2.radius
            }, 'gray', false);
            (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, init2.start, init2.end, 'gray');
            if (isSimulationRunning) {
                // Draw solid circles during simulation
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                    ...obj1.position,
                    radius: obj1.radius
                }, 'blue', true);
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                    ...obj2.position,
                    radius: obj2.radius
                }, 'red', true);
            }
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                'Drag initial positions and velocities',
                [
                    "Object 1",
                    Object.entries(obj1)
                ],
                [
                    "Object 2",
                    Object.entries(obj2)
                ],
                [
                    'Restitution',
                    restitution
                ],
                'Press +/- to adjust mass of first object',
                'Press [/] to adjust mass of second object',
                'Press 1/2 to adjust restitution',
                'Press R to replay simulation'
            ]);
        }
        function start() {
            obj1 = {
                ...obj1,
                position: {
                    ...init1.start
                },
                velocity: (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)((0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(init1.end, init1.start), .1)
            };
            obj2 = {
                ...obj2,
                position: {
                    ...init2.start
                },
                velocity: (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)((0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(init2.end, init2.start), .1)
            };
            isSimulationRunning = true;
        }
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>{
                draggedPosition = (0, $ee083671c43a5e14$export$ff7f7c97cdce86e)(pos, [
                    init1.start,
                    init1.end,
                    init2.start,
                    init2.end
                ]);
            },
            onDrag: (pos)=>{
                if (draggedPosition) {
                    draggedPosition.x = pos.x;
                    draggedPosition.y = pos.y;
                }
            },
            onEnd: ()=>{
                draggedPosition = null;
                start();
            }
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            'r': start,
            '+': ()=>obj1.mass += 0.1,
            '-': ()=>obj1.mass -= 0.1,
            '[': ()=>obj2.mass -= 0.1,
            ']': ()=>obj2.mass += 0.1,
            '1': ()=>restitution = Math.max(restitution - 0.1, 0),
            '2': ()=>restitution = Math.min(restitution + 0.1, 1)
        });
        let restitution = 0.9; // Default restitution
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(()=>{
            if (isSimulationRunning) {
                obj1.position.x += obj1.velocity.x;
                obj1.position.y += obj1.velocity.y;
                obj2.position.x += obj2.velocity.x;
                obj2.position.y += obj2.velocity.y;
                if ((0, $ee083671c43a5e14$export$9f17032d917177de)(obj1.position, obj2.position) < obj1.radius + obj2.radius) $5dda501f4a9774dc$export$98e6d07575f46913(obj1, obj2, restitution);
            }
        }, draw);
    },
    separate: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const objects = Array.from({
            length: 5
        }, ()=>createRandomObject());
        function createRandomObject(position = {
            x: canvas.width / 2 + Math.random() * 50 - 25,
            y: canvas.height / 2 + Math.random() * 50 - 25
        }) {
            const radius = Math.random() * 20 + 10; // Random radius between 10 and 30
            return {
                position: position,
                velocity: {
                    x: 0,
                    y: 0
                },
                mass: radius / 10,
                radius: radius
            };
        }
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            objects.forEach((obj)=>{
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                    ...obj.position,
                    radius: obj.radius
                }, 'blue');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                'Click to add a new random size object'
            ]);
        }
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(()=>{
            for(let i = 0; i < objects.length; i++)for(let j = i + 1; j < objects.length; j++)$5dda501f4a9774dc$export$709f6946f4e97408(objects[i], objects[j]);
        }, draw);
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, (pos)=>{
            const noise = ()=>Math.random() * 2 - 1; // Random noise between -1 and 1
            const noisyPos = {
                x: pos.x + noise(),
                y: pos.y + noise()
            };
            objects.push(createRandomObject(noisyPos));
        });
    },
    repel: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const objects = Array.from({
            length: 5
        }, ()=>createRandomObject());
        let repelStrength = 0.001;
        let friction = 0.99;
        function createRandomObject(position = {
            x: canvas.width / 2 + Math.random() * 50 - 25,
            y: canvas.height / 2 + Math.random() * 50 - 25
        }) {
            const radius = Math.random() * 20 + 10; // Random radius between 10 and 30
            return {
                position: position,
                velocity: {
                    x: 0,
                    y: 0
                },
                mass: radius / 10,
                radius: radius
            };
        }
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            objects.forEach((obj)=>{
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                    ...obj.position,
                    radius: obj.radius
                }, 'red');
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                'Click to add a new random size object',
                [
                    `Repel Strength`,
                    repelStrength,
                    {
                        precision: 4
                    }
                ],
                [
                    `Friction`,
                    friction
                ],
                'Use +/- to change repel strength',
                'Use [/] to change friction'
            ]);
        }
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(()=>{
            for(let i = 0; i < objects.length; i++)for(let j = i + 1; j < objects.length; j++)$5dda501f4a9774dc$export$168bb2ff78cb66b4(objects[i], objects[j], repelStrength);
            // Update positions based on velocities
            objects.forEach((obj)=>{
                obj.position.x += obj.velocity.x;
                obj.position.y += obj.velocity.y;
                // Apply drag to slow down the velocity
                obj.velocity.x *= friction;
                obj.velocity.y *= friction;
            });
        }, draw);
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>repelStrength += .001,
            '-': ()=>repelStrength -= .001,
            '[': ()=>friction -= .01,
            ']': ()=>friction += .01
        });
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, (pos)=>{
            const noise = ()=>Math.random() * 2 - 1; // Random noise between -1 and 1
            const noisyPos = {
                x: pos.x + noise(),
                y: pos.y + noise()
            };
            objects.push(createRandomObject(noisyPos));
        });
    },
    fluid: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const particles = Array.from({
            length: 1500
        }, ()=>({
                position: {
                    x: canvas.width / 2 + Math.random() * 150 - 25,
                    y: canvas.height / 2 + Math.random() * 150 - 25
                },
                velocity: {
                    x: 0,
                    y: 0
                },
                density: 0,
                pressure: 0,
                mass: 1
            }));
        const settings = {
            smoothingRadius: 15,
            stiffness: 5,
            restDensity: 1,
            viscosity: 0.5
        };
        const gravity = {
            x: 0,
            y: 0.1
        }; // Gravity force
        let lastMousePos = null;
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            particles.forEach((p)=>(0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                    ...p.position,
                    radius: 5
                }, 'blue')); // Reduced radius to 2
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                'Fluid simulation',
                [
                    'Particles',
                    particles.length,
                    {
                        precision: 0
                    }
                ],
                [
                    'Fluid',
                    Object.entries(settings)
                ],
                'Click and drag to apply forces'
            ]);
        }
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(()=>{
            const forces = $5dda501f4a9774dc$export$86e87f677abfca4b(particles, settings);
            particles.forEach((p, i)=>{
                // Apply fluid forces
                p.velocity.x += forces[i].x;
                p.velocity.y += forces[i].y;
                // Apply gravity
                p.velocity.x += gravity.x;
                p.velocity.y += gravity.y;
                // Update position
                p.position.x += p.velocity.x;
                p.position.y += p.velocity.y;
                // Keep particles within canvas bounds
                if (p.position.x < 0 || p.position.x > canvas.width) {
                    p.velocity.x *= -0.5; // Reverse and dampen velocity
                    p.position.x = Math.max(0, Math.min(canvas.width, p.position.x));
                }
                if (p.position.y < 0 || p.position.y > canvas.height) {
                    p.velocity.y *= -0.5; // Reverse and dampen velocity
                    p.position.y = Math.max(0, Math.min(canvas.height, p.position.y));
                }
            });
        }, draw);
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>{
                lastMousePos = pos;
            },
            onDrag: (pos)=>{
                if (lastMousePos) {
                    const dragForce = 2.5; // Strength of the drag force
                    const dragVector = (0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(pos, lastMousePos);
                    particles.forEach((p)=>{
                        const dist = (0, $ee083671c43a5e14$export$9f17032d917177de)(p.position, pos);
                        if (dist < 50) {
                            const force = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(dragVector, dragForce / (dist + 1)); // Inverse distance weighting
                            p.velocity.x += force.x;
                            p.velocity.y += force.y;
                        }
                    });
                }
                lastMousePos = pos;
            },
            onEnd: ()=>{
                lastMousePos = null;
            }
        });
    },
    boids: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const boids = Array.from({
            length: 30
        }, ()=>({
                position: {
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height
                },
                velocity: {
                    x: Math.random() * 2 - 1,
                    y: Math.random() * 2 - 1
                }
            }));
        const settings = {
            separationRadius: 25,
            alignmentRadius: 50,
            cohesionRadius: 50,
            separationWeight: 1.5,
            alignmentWeight: 2,
            cohesionWeight: 0.1,
            maxSpeed: 0.12
        };
        const wallAvoidanceRadius = 50; // Distance to start avoiding walls
        const wallAvoidanceWeight = 2; // Strength of wall avoidance
        const mouseAvoidanceRadius = 100; // Distance to start avoiding the mouse
        const mouseAvoidanceWeight = 5; // Strength of mouse avoidance
        let mousePos = null;
        const wanderingAngles = Array.from({
            length: boids.length
        }, ()=>Math.random() * Math.PI * 2);
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            boids.forEach((b)=>{
                const angle = Math.atan2(b.velocity.y, b.velocity.x);
                const bodyLength = 20;
                const bodyWidth = 10;
                // Draw boid as a longer arrow
                ctx.save();
                ctx.translate(b.position.x, b.position.y);
                ctx.rotate(angle);
                ctx.beginPath();
                ctx.moveTo(bodyLength / 2, 0); // Arrow tip
                ctx.lineTo(-bodyLength / 2, -bodyWidth / 2); // Left wing
                ctx.lineTo(-bodyLength / 2, bodyWidth / 2); // Right wing
                ctx.closePath();
                ctx.fillStyle = 'blue';
                ctx.fill();
                ctx.strokeStyle = 'black';
                ctx.stroke();
                ctx.restore();
            });
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                'Flocking simulation',
                ...Object.entries(settings).map(([key, value])=>[
                        key,
                        value
                    ])
            ]);
        }
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>{
            mousePos = pos;
        });
        (0, $086612735116fd75$export$e3607ec2d7a891c4)(()=>{
            const forces = $5dda501f4a9774dc$export$fbe21c35773c13ce(boids, settings);
            boids.forEach((b, i)=>{
                // Apply forces to velocity
                b.velocity.x += forces[i].x;
                b.velocity.y += forces[i].y;
                // Gradual wandering behavior for isolated boids
                if (forces[i].x === 0 && forces[i].y === 0) {
                    wanderingAngles[i] += (Math.random() - 0.5) * 0.1; // Gradually change angle
                    const wanderForce = (0, $97fc7d4a5f524dad$export$b1d53cea8aef9694)(wanderingAngles[i], settings.maxSpeed);
                    b.velocity = (0, $97fc7d4a5f524dad$export$e16d8520af44a096)(b.velocity, wanderForce);
                }
                // Wall avoidance
                const wallForces = {
                    x: 0,
                    y: 0
                };
                if (b.position.x < wallAvoidanceRadius) wallForces.x += wallAvoidanceWeight / Math.max(b.position.x, 1);
                if (b.position.x > canvas.width - wallAvoidanceRadius) wallForces.x -= wallAvoidanceWeight / Math.max(canvas.width - b.position.x, 1);
                if (b.position.y < wallAvoidanceRadius) wallForces.y += wallAvoidanceWeight / Math.max(b.position.y, 1);
                if (b.position.y > canvas.height - wallAvoidanceRadius) wallForces.y -= wallAvoidanceWeight / Math.max(canvas.height - b.position.y, 1);
                b.velocity = (0, $97fc7d4a5f524dad$export$e16d8520af44a096)(b.velocity, wallForces);
                // Mouse avoidance
                if (mousePos) {
                    const mouseDist = (0, $ee083671c43a5e14$export$9f17032d917177de)(b.position, mousePos);
                    if (mouseDist < mouseAvoidanceRadius) {
                        const awayFromMouse = (0, $97fc7d4a5f524dad$export$a3295358bff77e)((0, $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3)(b.position, mousePos));
                        const mouseForce = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(awayFromMouse, mouseAvoidanceWeight / Math.max(mouseDist, 1));
                        b.velocity = (0, $97fc7d4a5f524dad$export$e16d8520af44a096)(b.velocity, mouseForce);
                    }
                }
                // Apply damping
                b.velocity = (0, $97fc7d4a5f524dad$export$dcdf75081b88279d)(b.velocity, 0.95);
                // Update position
                b.position = (0, $97fc7d4a5f524dad$export$e16d8520af44a096)(b.position, b.velocity);
                // Prevent boids from leaving the canvas
                b.position.x = Math.max(0, Math.min(canvas.width, b.position.x));
                b.position.y = Math.max(0, Math.min(canvas.height, b.position.y));
            });
        }, draw);
    }
};







const $441597d29ead1611$export$695b29557618ac72 = {
    "Balls": (canvas)=>{
        const ctx = canvas.getContext('2d');
        class Ball extends (0, $e80cf0db060d44c4$export$324e885649fee72) {
            constructor(x, y, radius){
                super({
                    x: x,
                    y: y,
                    mass: Math.PI * radius * radius,
                    gravity: (0, $e80cf0db060d44c4$export$324e885649fee72).DOWNWARD_GRAVITY
                }), this.grabbed = false, this.grabOffset = {
                    x: 0,
                    y: 0
                };
                this.radius = radius;
            }
        }
        const balls = [];
        let draggedBall = null;
        const mousePos = {
            x: 0,
            y: 0
        };
        const dragStart = {
            x: 0,
            y: 0
        };
        const lastPos = {
            x: 0,
            y: 0
        };
        let lastTime = 0;
        const overlapModes = [
            'separate',
            'repel',
            'none'
        ];
        let currentOverlapModeIndex = 0;
        const addBall = ()=>{
            const radius = 10 + Math.random() * 20;
            const ball = new Ball(Math.random() * canvas.width, Math.random() * canvas.height * 0.5, radius);
            ball.velocity = {
                x: Math.random() * 200 - 100,
                y: Math.random() * 200 - 100
            };
            ball.collisionOverlapResolution = overlapModes[currentOverlapModeIndex];
            balls.push(ball);
        };
        const removeBall = ()=>{
            if (balls.length > 0) balls.pop();
        };
        const resetBalls = ()=>{
            balls.length = 0;
            Array.from({
                length: 10
            }).forEach(addBall);
        };
        const toggleOverlapMode = ()=>{
            currentOverlapModeIndex = (currentOverlapModeIndex + 1) % overlapModes.length;
            balls.forEach((ball)=>{
                ball.collisionOverlapResolution = overlapModes[currentOverlapModeIndex];
            });
        };
        resetBalls();
        const update = (deltaTime)=>{
            // Update physics
            balls.forEach((ball)=>{
                if (ball.grabbed) {
                    ball.velocity.x = 0;
                    ball.velocity.y = 0;
                    ball.position.x = mousePos.x - ball.grabOffset.x;
                    ball.position.y = mousePos.y - ball.grabOffset.y;
                    ball.mass = Number.MAX_SAFE_INTEGER; // Give maximum mass while dragging
                } else {
                    ball.mass = Math.PI * ball.radius * ball.radius; // Reset mass
                    ball.update(deltaTime);
                    // Wall collisions
                    ball.collideWithSurface({
                        x: 0,
                        y: 0
                    }, {
                        x: 1,
                        y: 0
                    }); // Left wall
                    ball.collideWithSurface({
                        x: canvas.width,
                        y: 0
                    }, {
                        x: -1,
                        y: 0
                    }); // Right wall
                    ball.collideWithSurface({
                        x: 0,
                        y: 0
                    }, {
                        x: 0,
                        y: 1
                    }); // Top wall
                    ball.collideWithSurface({
                        x: 0,
                        y: canvas.height
                    }, {
                        x: 0,
                        y: -1
                    }); // Bottom wall
                }
            });
            // Ball-to-ball collisions
            balls.forEach((b1, i)=>{
                balls.slice(i + 1).forEach((b2)=>{
                    b1.collideWithBody(b2);
                });
            });
        };
        const draw = ()=>{
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            balls.forEach((ball)=>{
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, ball, ball.grabbed ? 'red' : 'blue', true);
            });
            // Show results
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Number of Balls',
                    balls.length,
                    {
                        precision: 0
                    }
                ],
                [
                    'Overlap Mode',
                    overlapModes[currentOverlapModeIndex]
                ],
                'Drag balls to move them',
                'Press +/- to add/remove a ball',
                'Press R to reset',
                'Press O to toggle overlap mode'
            ]);
        };
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>{
                mousePos.x = pos.x;
                mousePos.y = pos.y;
                dragStart.x = pos.x;
                dragStart.y = pos.y;
                lastPos.x = pos.x;
                lastPos.y = pos.y;
                lastTime = performance.now();
                balls.forEach((ball)=>{
                    const dist = $ee083671c43a5e14$export$9f17032d917177de(ball.position, mousePos);
                    if (dist <= ball.radius) {
                        ball.grabbed = true;
                        draggedBall = ball;
                        ball.grabOffset = $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(mousePos, ball.position);
                    }
                });
            },
            onDrag: (pos)=>{
                lastPos.x = mousePos.x;
                lastPos.y = mousePos.y;
                mousePos.x = pos.x;
                mousePos.y = pos.y;
                lastTime = performance.now();
                if (draggedBall) draggedBall.position = $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(mousePos, draggedBall.grabOffset);
            },
            onEnd: ()=>{
                if (draggedBall) {
                    const currentTime = performance.now();
                    const dt = (currentTime - lastTime) / 1000;
                    if (dt > 0) {
                        // Calculate velocity based on movement over time
                        const dragVel = $97fc7d4a5f524dad$export$dcdf75081b88279d($97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(mousePos, lastPos), 1 / dt // Divide by time to get velocity
                        );
                        draggedBall.velocity = dragVel;
                    }
                    draggedBall.grabbed = false;
                    draggedBall = null;
                }
            }
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': addBall,
            '-': removeBall,
            'r': resetBalls,
            'o': toggleOverlapMode
        });
        return (0, $086612735116fd75$export$1e61084297db69ac)(update, draw);
    },
    "Billiards": (canvas)=>{
        const ctx = canvas.getContext('2d');
        class BilliardBall extends (0, $e80cf0db060d44c4$export$324e885649fee72) {
            constructor(x, y, color){
                super({
                    x: x,
                    y: y,
                    mass: 1
                }), this.grabbed = false, this.grabOffset = {
                    x: 0,
                    y: 0
                };
                this.radius = 15;
                this.color = color;
                this.elasticity = 0.95;
                this.friction = 0.01;
            }
        }
        const balls = [];
        const pockets = [
            {
                x: 20,
                y: 20
            },
            {
                x: canvas.width / 2,
                y: 20
            },
            {
                x: canvas.width - 20,
                y: 20
            },
            {
                x: 20,
                y: canvas.height - 20
            },
            {
                x: canvas.width / 2,
                y: canvas.height - 20
            },
            {
                x: canvas.width - 20,
                y: canvas.height - 20
            } // Bottom-right
        ];
        const pocketRadius = 25;
        const colors = [
            'white',
            'gold',
            'royalblue',
            'crimson',
            'purple',
            'darkorange',
            'forestgreen',
            'saddlebrown',
            'black',
            'khaki',
            'steelblue',
            'indianred',
            'darkmagenta',
            'coral',
            'seagreen',
            'sienna' // 15
        ];
        let draggedBall = null;
        const mousePos = {
            x: 0,
            y: 0
        };
        const dragStart = {
            x: 0,
            y: 0
        };
        const resetBalls = ()=>{
            balls.length = 0;
            balls.push(new BilliardBall(200, canvas.height / 2, colors[0])); // Cue ball
            let row = 0;
            let idx = 1;
            for(let y = -2; y <= 2; y++){
                for(let x = 0; x <= row; x++)if (idx < colors.length) balls.push(new BilliardBall(// Centered along the midline x-axis, facing left
                550 + row * 15, canvas.height / 2 + x * 30 - row * 15, colors[idx++]));
                row++;
            }
        };
        resetBalls();
        const update = (deltaTime)=>{
            balls.forEach((ball)=>{
                ball.update(deltaTime);
                // Cushion collisions
                const wallPadding = 10;
                ball.collideWithSurface({
                    x: wallPadding,
                    y: 0
                }, {
                    x: 1,
                    y: 0
                }); // Left wall
                ball.collideWithSurface({
                    x: canvas.width - wallPadding,
                    y: 0
                }, {
                    x: -1,
                    y: 0
                }); // Right wall
                ball.collideWithSurface({
                    x: 0,
                    y: wallPadding
                }, {
                    x: 0,
                    y: 1
                }); // Top wall
                ball.collideWithSurface({
                    x: 0,
                    y: canvas.height - wallPadding
                }, {
                    x: 0,
                    y: -1
                }); // Bottom wall
            });
            // Ball collisions
            balls.forEach((b1, i)=>{
                balls.slice(i + 1).forEach((b2)=>{
                    b1.collideWithBody(b2);
                });
            });
            // Check for balls in pockets
            for(let i = balls.length - 1; i >= 0; i--){
                const ball = balls[i];
                const inPocket = pockets.some((pocket)=>$ee083671c43a5e14$export$9f17032d917177de(ball.position, pocket) < pocketRadius);
                if (inPocket) {
                    if (ball.color === 'white') {
                        // Reset cue ball to starting position
                        ball.position = {
                            x: 200,
                            y: canvas.height / 2
                        };
                        ball.velocity = $97fc7d4a5f524dad$export$b1d53cea8aef9694(Math.random() * Math.PI * 2, 50);
                    } else balls.splice(i, 1); // Remove ball
                }
            }
        };
        const draw = ()=>{
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            // Draw wooden frame
            const wallPadding = 10; // Match wall padding
            (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, {
                x: 0,
                y: 0,
                width: canvas.width,
                height: canvas.height
            }, 'brown', true); // Outer frame
            (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, {
                x: wallPadding,
                y: wallPadding,
                width: canvas.width - 2 * wallPadding,
                height: canvas.height - 2 * wallPadding
            }, 'darkgreen', true); // Inner table
            // Draw pockets
            pockets.forEach((pocket)=>{
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                    x: pocket.x,
                    y: pocket.y,
                    radius: pocketRadius
                }, 'black', true);
            });
            // Draw balls
            balls.forEach((ball)=>{
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, ball, ball.color, true);
            });
            // Draw aiming line
            if (draggedBall) {
                const pullBack = $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(dragStart, mousePos);
                const aimLine = $97fc7d4a5f524dad$export$dcdf75081b88279d(pullBack, 2);
                // Draw power gauge
                (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                    start: draggedBall.position,
                    end: $97fc7d4a5f524dad$export$e16d8520af44a096(draggedBall.position, aimLine)
                }, 'rgba(255, 255, 255, .25)', 2);
                // Draw direction indicator
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                    x: draggedBall.position.x + aimLine.x,
                    y: draggedBall.position.y + aimLine.y,
                    radius: 2
                }, 'white', true);
            }
            // Show results
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Number of Balls',
                    balls.length,
                    {
                        precision: 0
                    }
                ],
                'Drag the cue ball to aim and shoot',
                'Press R to reset'
            ], {
                color: 'white'
            });
        };
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: (pos)=>{
                mousePos.x = pos.x;
                mousePos.y = pos.y;
                dragStart.x = pos.x;
                dragStart.y = pos.y;
                const cueBall = balls[0];
                if ($ee083671c43a5e14$export$9f17032d917177de(cueBall.position, mousePos) <= cueBall.radius) draggedBall = cueBall;
            },
            onDrag: (pos)=>{
                mousePos.x = pos.x;
                mousePos.y = pos.y;
            },
            onEnd: ()=>{
                if (draggedBall) {
                    const pullBack = $97fc7d4a5f524dad$export$4e2d2ead65e5f7e3(dragStart, mousePos);
                    draggedBall.velocity = $97fc7d4a5f524dad$export$e16d8520af44a096(draggedBall.velocity, $97fc7d4a5f524dad$export$dcdf75081b88279d(pullBack, 10));
                    draggedBall = null;
                }
            }
        });
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            'r': resetBalls
        });
        return (0, $086612735116fd75$export$1e61084297db69ac)(update, draw);
    },
    "Spaceship": (canvas)=>{
        const ctx = canvas.getContext('2d');
        class Spaceship extends (0, $e80cf0db060d44c4$export$324e885649fee72) {
            constructor(){
                super({
                    x: canvas.width / 2,
                    y: canvas.height / 2,
                    mass: 1
                }), this.thrusting = false;
                this.radius = 20;
            }
            thrust() {
                const force = $97fc7d4a5f524dad$export$b1d53cea8aef9694(this.angle, 500);
                this.applyForce(force);
            }
            update(deltaTime) {
                // Apply minimal drag
                this.velocity = $97fc7d4a5f524dad$export$dcdf75081b88279d(this.velocity, 0.999);
                super.update(deltaTime);
                // Wrap around edges
                this.position.x = (this.position.x + canvas.width) % canvas.width;
                this.position.y = (this.position.y + canvas.height) % canvas.height;
            }
        }
        const ship = new Spaceship();
        // Generate stars
        const stars = Array.from({
            length: 100
        }, ()=>({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                color: `rgba(${200 + Math.random() * 55}, ${200 + Math.random() * 55}, ${200 + Math.random() * 55}, 1)`,
                size: Math.random() * 2 + 1
            }));
        let particles = [];
        (0, $086612735116fd75$export$ed97f33186d4b816).listen();
        const update = (deltaTime)=>{
            if ((0, $086612735116fd75$export$ed97f33186d4b816).isDown('ArrowLeft')) ship.angle -= 4 * deltaTime;
            if ((0, $086612735116fd75$export$ed97f33186d4b816).isDown('ArrowRight')) ship.angle += 4 * deltaTime;
            if ((0, $086612735116fd75$export$ed97f33186d4b816).isDown('ArrowUp')) {
                ship.thrust();
                ship.thrusting = true;
                // Emit particles
                for(let i = 0; i < 3; i++){
                    const thrustVector = $97fc7d4a5f524dad$export$b1d53cea8aef9694(ship.angle, -15);
                    particles.push({
                        x: ship.position.x + thrustVector.x + (Math.random() - 0.5) * 10,
                        y: ship.position.y + thrustVector.y + (Math.random() - 0.5) * 10,
                        radius: Math.random() * 3 + 1,
                        life: 1,
                        velocity: $97fc7d4a5f524dad$export$e16d8520af44a096($97fc7d4a5f524dad$export$b1d53cea8aef9694(ship.angle, -100), $97fc7d4a5f524dad$export$b1d53cea8aef9694(Math.random() * Math.PI * 2, Math.random() * 50))
                    });
                }
            } else ship.thrusting = false;
            ship.update(deltaTime);
            // Update particles
            particles.forEach((p)=>{
                p.life -= deltaTime;
                p.x += p.velocity.x * deltaTime;
                p.y += p.velocity.y * deltaTime;
                // Apply friction to slow down particles
                p.velocity = $97fc7d4a5f524dad$export$dcdf75081b88279d(p.velocity, 0.95);
                p.radius *= 0.95; // Shrink over time
            });
            particles = particles.filter((p)=>p.life > 0); // Remove dead particles
        };
        const draw = ()=>{
            // Draw black background
            (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, {
                x: 0,
                y: 0,
                width: canvas.width,
                height: canvas.height
            }, 'black', true);
            // Draw stars
            stars.forEach((star)=>{
                (0, $086612735116fd75$export$654275d54901f10e)(ctx, {
                    x: star.x,
                    y: star.y
                }, star.color, star.size);
            });
            // Draw particles
            particles.forEach((p)=>{
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                    x: p.x,
                    y: p.y,
                    radius: p.radius
                }, 'orange', true);
            });
            // Draw spaceship
            ctx.save();
            ctx.translate(ship.position.x, ship.position.y);
            ctx.rotate(ship.angle);
            // Draw ship body
            ctx.beginPath();
            ctx.moveTo(20, 0);
            ctx.lineTo(-10, 10);
            ctx.lineTo(-10, -10);
            ctx.closePath();
            ctx.strokeStyle = 'white';
            ctx.stroke();
            // Draw thrust
            if (ship.thrusting) {
                ctx.beginPath();
                ctx.moveTo(-10, 0);
                const spikes = 5;
                for(let i = 0; i <= spikes; i++){
                    const angle = i / spikes * Math.PI / 3 - Math.PI / 6; // Symmetrical angle range
                    const length = 10 + Math.random() * 10; // Random spiky length
                    ctx.lineTo(-10 - length * Math.cos(angle), length * Math.sin(angle));
                }
                ctx.closePath();
                ctx.fillStyle = 'orange';
                ctx.fill();
            }
            ctx.restore();
        };
        return (0, $086612735116fd75$export$1e61084297db69ac)(update, draw);
    },
    "Artillery": (canvas)=>{
        const ctx = canvas.getContext('2d');
        class Cannon {
            constructor(x, y){
                this.angle = -Math.PI / 4;
                this.power = 0;
                this.charging = false;
                this.chargeStartTime = 0;
                this.position = {
                    x: x,
                    y: y
                };
            }
            startCharging() {
                this.charging = true;
                this.chargeStartTime = performance.now();
            }
            stopCharging() {
                this.charging = false;
                this.power = this.calculatePower();
            }
            calculatePower() {
                const minPower = 100;
                const maxPower = 1000;
                const powerPerSecond = 500;
                const chargeDuration = (performance.now() - this.chargeStartTime) / 1000; // in seconds
                return Math.min(maxPower, minPower + chargeDuration * powerPerSecond);
            }
        }
        class Cannonball extends (0, $e80cf0db060d44c4$export$324e885649fee72) {
            constructor(position, velocity){
                super({
                    position: position,
                    velocity: velocity,
                    mass: 5,
                    gravity: {
                        x: 0,
                        y: 500
                    }
                });
                this.radius = 5;
            }
        }
        class Target extends (0, $e80cf0db060d44c4$export$324e885649fee72) {
            constructor(x){
                super({
                    x: x,
                    y: canvas.height - 50,
                    mass: 10 // Give the target some mass to react to collisions
                }), this.hit = false;
                this.radius = 20;
            }
            applyGravity() {
                this.gravity = {
                    x: 0,
                    y: 500
                }; // Apply downward gravity
            }
            reset() {
                this.hit = false;
                this.gravity = {
                    x: 0,
                    y: 0
                }; // Remove gravity
                this.velocity = {
                    x: 0,
                    y: 0
                }; // Reset velocity
                this.position.x = Math.random() * (canvas.width - 200) + 100; // Random x position
                this.position.y = Math.random() * (canvas.height - 200); // Random y position
            }
        }
        const cannon = new Cannon(50, canvas.height - 50);
        const target = new Target(canvas.width - 100);
        let cannonball = null;
        let score = 0;
        const ground = canvas.height - 30;
        (0, $086612735116fd75$export$d7d5d435647ed5a0)({
            canvas: canvas,
            draw: draw
        }, {
            onStart: ()=>{
                cannon.startCharging();
            },
            onEnd: ()=>{
                cannon.stopCharging();
                const velocity = $97fc7d4a5f524dad$export$b1d53cea8aef9694(cannon.angle, cannon.power);
                cannonball = new Cannonball({
                    ...cannon.position
                }, velocity);
            }
        });
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas
        }, (pos)=>{
            cannon.angle = (0, $7d6e798d0a09cf0e$exports).radiansBetweenPoints(cannon.position, pos);
        });
        const update = (deltaTime)=>{
            if (cannonball) {
                cannonball.update(deltaTime);
                // Check for collision with the target
                if (!target.hit && cannonball.collideWithBody(target)) {
                    target.hit = true;
                    target.applyGravity(); // Apply gravity to the target
                    score++;
                    cannonball = null;
                } else if (cannonball.position.y > ground) cannonball = null;
            }
            // Update target physics
            target.update(deltaTime);
            // Reset target if it falls below the ground
            if (target.position.y > ground) target.reset();
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            // Draw ground
            (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, {
                x: 0,
                y: ground,
                width: canvas.width,
                height: canvas.height - ground
            }, '#764', true);
            // Draw cannon base
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                x: cannon.position.x,
                y: cannon.position.y,
                radius: 15
            }, '#333', true);
            // Draw cannon
            const cannonEnd = $97fc7d4a5f524dad$export$e16d8520af44a096(cannon.position, $97fc7d4a5f524dad$export$b1d53cea8aef9694(cannon.angle, 30) // Cannon length
            );
            (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                start: cannon.position,
                end: cannonEnd
            }, '#333', 10);
            // Visualize charged power with a red arrow
            if (cannon.charging) {
                const power = cannon.calculatePower();
                const powerArrowEnd = $97fc7d4a5f524dad$export$e16d8520af44a096(cannon.position, $97fc7d4a5f524dad$export$b1d53cea8aef9694(cannon.angle, power / 10) // Scale power for visualization
                );
                (0, $086612735116fd75$export$f6d70d79295e1392)(ctx, cannon.position, powerArrowEnd, 'red');
            }
            // Draw target
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, target, target.hit ? 'red' : 'blue', true);
            // Draw cannonball
            if (cannonball) (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, cannonball, '#333', true);
            // Draw score and power
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Score',
                    score,
                    {
                        precision: 0
                    }
                ],
                [
                    'Angle',
                    (0, $7d6e798d0a09cf0e$exports).radiansToDegrees(cannon.angle)
                ],
                [
                    'Power',
                    cannon.charging ? cannon.calculatePower() : cannon.power
                ],
                "Click and hold to charge cannon"
            ]);
        }
        return (0, $086612735116fd75$export$1e61084297db69ac)(update, draw);
    },
    "Tank": (canvas)=>{
        const ctx = canvas.getContext('2d');
        class Tank extends (0, $e80cf0db060d44c4$export$324e885649fee72) {
            constructor(){
                super({
                    x: canvas.width / 2,
                    y: canvas.height / 2,
                    mass: 5
                }), this.angle = 0, this.turretAngle = 0, this.throttle = 0, this.turretRotationSpeed = 5;
                this.radius = 20;
                this.mass = 100;
            }
            update(deltaTime) {
                // Update turret angle based on mouse position
                const mouseTargetAngle = (0, $7d6e798d0a09cf0e$exports).radiansBetweenPoints(this.position, mousePos);
                this.turretAngle = (0, $7d6e798d0a09cf0e$exports).rotateAngleTowardsRadians(this.turretAngle, mouseTargetAngle, this.turretRotationSpeed * deltaTime);
                // Tank movement -- always move in the direction of the tank's angle
                this.velocity = $97fc7d4a5f524dad$export$b1d53cea8aef9694(tank.angle, tank.throttle);
                // Apply drag
                this.throttle *= 0.99;
                super.update(deltaTime);
            }
        }
        class Bullet extends (0, $e80cf0db060d44c4$export$324e885649fee72) {
            constructor(position, angle){
                super({
                    position: position,
                    velocity: $97fc7d4a5f524dad$export$b1d53cea8aef9694(angle, 2500)
                }), this.timeAlive = 0;
                this.radius = 3;
                this.mass = 25;
            }
        }
        class Obstacle extends (0, $e80cf0db060d44c4$export$324e885649fee72) {
            constructor(x, y, radius){
                super({
                    x: x,
                    y: y,
                    mass: radius * 10
                });
                this.radius = radius;
                this.elasticity = 0.8;
                this.friction = 0.2;
            }
        }
        const tank = new Tank();
        const bullets = [];
        const obstacles = Array.from({
            length: 15
        }, ()=>new Obstacle(Math.random() * canvas.width, Math.random() * canvas.height, 10 + Math.random() * 20));
        const mousePos = {
            x: 0,
            y: 0
        };
        // Use move() to update turret angle based on mouse position
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>{
            mousePos.x = pos.x;
            mousePos.y = pos.y;
        });
        // Use click() to fire bullets
        (0, $086612735116fd75$export$64ef1bee2b9504c1)({
            canvas: canvas,
            draw: draw
        }, ()=>{
            const bulletPos = $97fc7d4a5f524dad$export$e16d8520af44a096(tank.position, $97fc7d4a5f524dad$export$b1d53cea8aef9694(tank.turretAngle, tank.radius));
            bullets.push(new Bullet(bulletPos, tank.turretAngle));
        });
        (0, $086612735116fd75$export$ed97f33186d4b816).listen();
        const update = (deltaTime)=>{
            // Tank movement controls using keys.isDown()
            const turnSpeed = 2;
            const throttleSpeed = 400;
            if ((0, $086612735116fd75$export$ed97f33186d4b816).isDown('ArrowLeft')) tank.angle -= turnSpeed * deltaTime;
            if ((0, $086612735116fd75$export$ed97f33186d4b816).isDown('ArrowRight')) tank.angle += turnSpeed * deltaTime;
            if ((0, $086612735116fd75$export$ed97f33186d4b816).isDown('ArrowUp')) tank.throttle = Math.min(200, tank.throttle + throttleSpeed * deltaTime);
            if ((0, $086612735116fd75$export$ed97f33186d4b816).isDown('ArrowDown')) tank.throttle = Math.max(-100, tank.throttle - throttleSpeed * deltaTime);
            // Tank movement
            tank.update(deltaTime);
            // Keep tank in bounds
            tank.position.x = Math.max(tank.radius, Math.min(canvas.width - tank.radius, tank.position.x));
            tank.position.y = Math.max(tank.radius, Math.min(canvas.height - tank.radius, tank.position.y));
            // Update bullets
            for(let i = bullets.length - 1; i >= 0; i--){
                const bullet = bullets[i];
                bullet.update(deltaTime);
                bullet.timeAlive += deltaTime;
                // Remove bullets that are too old or out of bounds
                if (bullet.timeAlive > 2 || bullet.position.x < 0 || bullet.position.x > canvas.width || bullet.position.y < 0 || bullet.position.y > canvas.height) bullets.splice(i, 1);
            }
            // Update obstacles
            obstacles.forEach((obstacle)=>obstacle.update(deltaTime));
            // Handle collisions between tank and obstacles
            obstacles.forEach((obstacle)=>tank.collideWithBody(obstacle));
            // Handle collisions between bullets and obstacles
            bullets.forEach((bullet)=>{
                obstacles.forEach((obstacle)=>bullet.collideWithBody(obstacle));
            });
            // Handle collisions between obstacles
            obstacles.forEach((o1, i)=>{
                obstacles.slice(i + 1).forEach((o2)=>o1.collideWithBody(o2));
            });
        };
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            // Draw tank body
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, tank.position, (ctx)=>{
                ctx.rotate(tank.angle);
                (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, {
                    x: -25,
                    y: -15,
                    width: 50,
                    height: 30
                }, '#3a3', true);
            });
            // Draw tank turret
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, tank.position, (ctx)=>{
                ctx.rotate(tank.turretAngle);
                const turretEnd = $97fc7d4a5f524dad$export$b1d53cea8aef9694(0, 30);
                (0, $086612735116fd75$export$819db45aec5fcbe5)(ctx, {
                    start: {
                        x: 0,
                        y: 0
                    },
                    end: turretEnd
                }, '#373', 10);
            });
            // Draw bullets
            bullets.forEach((bullet)=>{
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, bullet, "orange", true);
            });
            // Draw obstacles
            obstacles.forEach((obstacle)=>{
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, obstacle, "gray", true);
            });
            // Render speed in the output
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Speed',
                    tank.speed
                ],
                "Arrow Keys: Rotate and Throttle",
                "Click to Fire"
            ]);
        }
        return (0, $086612735116fd75$export$1e61084297db69ac)(update, draw);
    },
    "Car": (canvas)=>{
        const ctx = canvas.getContext('2d');
        class Car extends (0, $e80cf0db060d44c4$export$324e885649fee72) {
            constructor(){
                super({
                    x: canvas.width / 2,
                    y: canvas.height / 2,
                    mass: 2
                }), this.steering = 0, this.throttle = 0;
                this.radius = 20;
                this.mass = 20;
            }
            update(deltaTime) {
                // Apply steering
                this.angle += this.steering * this.throttle * deltaTime * 0.003;
                // Update velocity based on car's angle
                this.velocity = $97fc7d4a5f524dad$export$b1d53cea8aef9694(this.angle, this.throttle);
                // Apply drag
                this.throttle *= 0.99;
                super.update(deltaTime);
            }
        }
        class Obstacle extends (0, $e80cf0db060d44c4$export$324e885649fee72) {
            constructor(x, y, radius){
                super({
                    x: x,
                    y: y,
                    mass: radius ** 2
                });
                this.radius = radius;
                this.elasticity = 0.8;
                this.friction = 0.002;
            }
        }
        const car = new Car();
        const obstacles = Array.from({
            length: 50
        }, ()=>new Obstacle(Math.random() * canvas.width, Math.random() * canvas.height, 5 + Math.random() ** 5 * 25));
        (0, $086612735116fd75$export$ed97f33186d4b816).listen();
        const update = (deltaTime)=>{
            // Car controls using keys.isDown()
            const steeringSpeed = 1;
            if ((0, $086612735116fd75$export$ed97f33186d4b816).isDown('ArrowLeft')) car.steering = -steeringSpeed;
            else if ((0, $086612735116fd75$export$ed97f33186d4b816).isDown('ArrowRight')) car.steering = steeringSpeed;
            else car.steering = 0;
            const throttleSpeed = 400;
            if ((0, $086612735116fd75$export$ed97f33186d4b816).isDown('ArrowUp')) car.throttle = Math.min(300, car.throttle + throttleSpeed * deltaTime);
            if ((0, $086612735116fd75$export$ed97f33186d4b816).isDown('ArrowDown')) car.throttle = Math.max(-100, car.throttle - throttleSpeed * deltaTime);
            car.update(deltaTime);
            // Keep car in bounds
            car.position.x = (car.position.x + canvas.width) % canvas.width;
            car.position.y = (car.position.y + canvas.height) % canvas.height;
            // Update obstacles
            obstacles.forEach((obstacle)=>{
                obstacle.update(deltaTime);
                // Loop obstacles around the canvas
                obstacle.position.x = (obstacle.position.x + canvas.width) % canvas.width;
                obstacle.position.y = (obstacle.position.y + canvas.height) % canvas.height;
            });
            // Handle collisions between car and obstacles
            obstacles.forEach((obstacle)=>car.collideWithBody(obstacle));
            // Handle collisions between obstacles
            obstacles.forEach((o1, i)=>{
                obstacles.slice(i + 1).forEach((o2)=>o1.collideWithBody(o2));
            });
        };
        const draw = ()=>{
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            // Draw car body and wheels using drawWithOffset and drawRect
            (0, $086612735116fd75$export$b602ad7a6da8e372)(ctx, car.position, (ctx)=>{
                ctx.rotate(car.angle);
                // Draw car body
                (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, {
                    x: -20,
                    y: -10,
                    width: 40,
                    height: 20
                }, '#d33', true);
                // Draw wheels
                (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, {
                    x: -15,
                    y: -12,
                    width: 8,
                    height: 4
                }, '#333', true);
                (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, {
                    x: -15,
                    y: 8,
                    width: 8,
                    height: 4
                }, '#333', true);
                (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, {
                    x: 7,
                    y: -12,
                    width: 8,
                    height: 4
                }, '#333', true);
                (0, $086612735116fd75$export$92e8c004f9e4bf7d)(ctx, {
                    x: 7,
                    y: 8,
                    width: 8,
                    height: 4
                }, '#333', true);
            });
            // Draw obstacles
            obstacles.forEach((obstacle)=>{
                (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, obstacle, "gray", true);
            });
            // Render speed and steering in the output
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Speed',
                    car.speed
                ],
                [
                    'Steering',
                    car.steering
                ],
                "Arrow Keys: Steer and Accelerate"
            ]);
        };
        return (0, $086612735116fd75$export$1e61084297db69ac)(update, draw);
    },
    "Chase": (canvas)=>{
        const ctx = canvas.getContext('2d');
        class Bird extends (0, $e80cf0db060d44c4$export$324e885649fee72) {
            static{
                this.MIN_THRUST_SPEED = 200;
            }
            static{
                this.MAX_THRUST_SPEED = 1500;
            }
            get color() {
                const ratio = (this.thrustSpeed - Bird.MIN_THRUST_SPEED) / (Bird.MAX_THRUST_SPEED - Bird.MIN_THRUST_SPEED);
                const red = Math.round(255 * ratio);
                const blue = Math.round(255 * (1 - ratio));
                return `rgb(${red}, 0, ${blue})`;
            }
            constructor(x, y){
                super({
                    x: x,
                    y: y,
                    mass: 1
                }), this.thrustSpeed = Bird.MIN_THRUST_SPEED + (Bird.MAX_THRUST_SPEED - Bird.MIN_THRUST_SPEED) * Math.random() ** 3, this.turnSpeed = (0, $7d6e798d0a09cf0e$export$c9fcf1a7df975d78)(5), this.trail = [], this.trailLength = 20;
                this.radius = 5;
                this.maxSpeed = 1500;
                this.friction = 0.01;
            }
            chase(target) {
                this.pointTowards(target, this.turnSpeed);
                this.thrust(this.thrustSpeed);
            }
            update(deltaTime) {
                super.update(deltaTime);
                // Add the current position to the trail
                this.trail.push({
                    ...this.position
                });
                // Keep only the last 20 positions
                if (this.trail.length > this.trailLength) this.trail.shift();
            }
        }
        const birds = Array.from({
            length: 50
        }, ()=>new Bird(Math.random() * canvas.width, Math.random() * canvas.height));
        const addBirds = (count)=>{
            for(let i = 0; i < count; i++)birds.push(new Bird(Math.random() * canvas.width, Math.random() * canvas.height));
        };
        const removeBirds = (count)=>{
            birds.splice(-count, count);
        };
        let mousePos = {
            x: canvas.width / 2,
            y: canvas.height / 2
        };
        (0, $086612735116fd75$export$d947e5f4f4c48d48)({
            canvas: canvas,
            draw: draw
        }, (pos)=>{
            mousePos = pos;
        });
        function update(deltaTime) {
            birds.forEach((bird, i)=>{
                // Chase the mouse
                bird.chase(mousePos);
                // Repel from other birds
                birds.slice(i + 1).forEach((other)=>{
                    (0, $5dda501f4a9774dc$exports).repel(bird, other, 20);
                });
                bird.update(deltaTime);
            });
        }
        function draw() {
            (0, $086612735116fd75$export$a1c066623ac679d3)(ctx);
            // Draw birds
            birds.forEach((bird)=>{
                (0, $086612735116fd75$export$654275d54901f10e)(ctx, bird.position, bird.color, 2);
                // Draw the trailing path
                ctx.beginPath();
                bird.trail.forEach((pos)=>ctx.lineTo(pos.x, pos.y));
                ctx.strokeStyle = bird.color;
                ctx.stroke();
            });
            // Draw mouse position
            (0, $086612735116fd75$export$8daab6f91f7ff730)(ctx, {
                x: mousePos.x,
                y: mousePos.y,
                radius: 5
            }, 'red', true);
            // Render results
            (0, $086612735116fd75$export$4880d2177ba2b4c0)(ctx, [
                [
                    'Number of Birds',
                    birds.length,
                    {
                        precision: 0
                    }
                ],
                'Move the mouse to attract the birds',
                'Press +/- to add/remove 10 birds'
            ]);
        }
        (0, $086612735116fd75$export$df61b30b684217c0)({
            canvas: canvas,
            draw: draw
        }, {
            '+': ()=>addBirds(10),
            '-': ()=>removeBirds(10)
        });
        return (0, $086612735116fd75$export$1e61084297db69ac)(update, draw);
    }
};


const $1d47723cd548cd0a$export$7eb1b49cd2af1357 = {
    point: (0, $804439357c53744a$export$edaf19bb1d4a3d18),
    angle: (0, $1f98b464ed010556$export$4a0439d774561d41),
    intersection: (0, $fdcbb30aaeabb80a$export$10b0d1ad557ec395),
    vector: (0, $598db149d2af8004$export$f9d080264ca8206b),
    body: (0, $441597d29ead1611$export$695b29557618ac72),
    physics: (0, $51a78989f62341bf$export$3ee404efaa54ac8a)
};



function $d7fbee754ebec663$var$renderNav(currentSection, currentMethod) {
    return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div class="demo-nav">
      <div class="section-nav">
        ${Object.keys((0, $1d47723cd548cd0a$export$7eb1b49cd2af1357)).map((section)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
          <a href="#${section}" class="${section === currentSection ? 'active' : ''}">${section}</a>
        `)}
      </div>
      <div class="method-nav">
        ${currentSection && (0, $1d47723cd548cd0a$export$7eb1b49cd2af1357)[currentSection] && Object.keys((0, $1d47723cd548cd0a$export$7eb1b49cd2af1357)[currentSection]).map((method)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <a href="#${currentSection}/${method}" 
               class="${method === currentMethod ? 'active' : ''}">${method}</a>
          `)}
      </div>
    </div>
  `;
}
function $d7fbee754ebec663$var$renderDemo(section, method) {
    return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    ${$d7fbee754ebec663$var$renderNav(section, method)}
    ${(0, $e41d1b66de65ecc4$export$76d90c956114f2c2)([
        Date.now()
    ], (id)=>id, ()=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<canvas width="800" height="600"></canvas>`)}
  `;
}
function $d7fbee754ebec663$var$route() {
    const [section = 'point', method] = location.hash.slice(1).split('/');
    const demo = document.getElementById('demo');
    (0, $086612735116fd75$export$aad8462122ac592b)();
    (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)($d7fbee754ebec663$var$renderDemo(section, method), demo);
    const canvas = demo.querySelector('canvas');
    (0, $086612735116fd75$export$a1c066623ac679d3)(canvas.getContext('2d'));
    if (method && (0, $1d47723cd548cd0a$export$7eb1b49cd2af1357)[section]?.[method]) (0, $1d47723cd548cd0a$export$7eb1b49cd2af1357)[section][method](canvas);
}
window.addEventListener('hashchange', $d7fbee754ebec663$var$route);
$d7fbee754ebec663$var$route();


//# sourceMappingURL=demo.93048f35.js.map
